var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _path104, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _path105, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _path106, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _path137, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385, _circle386, _circle387, _circle388, _circle389, _circle390, _circle391, _circle392, _circle393, _circle394, _circle395, _path138, _circle396, _circle397, _circle398, _circle399, _circle400, _circle401, _circle402, _circle403, _circle404, _circle405, _circle406, _circle407, _circle408, _circle409, _circle410, _circle411, _circle412, _circle413, _circle414, _circle415, _g, _g2, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _circle416, _circle417, _circle418, _circle419, _circle420, _circle421, _circle422, _circle423, _circle424, _circle425, _circle426, _circle427, _circle428, _circle429, _circle430, _circle431, _circle432, _circle433, _circle434, _circle435, _circle436, _circle437, _path172, _circle438, _circle439, _circle440, _circle441, _circle442, _circle443, _circle444, _circle445, _circle446, _circle447, _circle448, _circle449, _circle450, _circle451, _circle452, _circle453, _circle454, _circle455, _circle456, _circle457, _circle458, _circle459, _circle460, _circle461, _circle462, _circle463, _circle464, _circle465, _circle466, _circle467, _circle468, _circle469, _circle470, _circle471, _circle472, _circle473, _circle474, _circle475, _circle476, _circle477, _circle478, _circle479, _circle480, _circle481, _circle482, _circle483, _circle484, _circle485, _circle486, _circle487, _circle488, _circle489, _circle490, _circle491, _circle492, _circle493, _circle494, _circle495, _circle496, _circle497, _circle498, _circle499, _circle500, _circle501, _circle502, _circle503, _circle504, _circle505, _circle506, _circle507, _circle508, _circle509, _circle510, _circle511, _circle512, _circle513, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _circle514, _circle515, _circle516, _circle517, _circle518, _circle519, _circle520, _circle521, _circle522, _circle523, _circle524, _circle525, _circle526, _circle527, _circle528, _circle529, _circle530, _circle531, _circle532, _circle533, _circle534, _circle535, _circle536, _circle537, _circle538, _circle539, _circle540, _circle541, _circle542, _circle543, _circle544, _circle545, _circle546, _circle547, _circle548, _circle549, _circle550, _circle551, _circle552, _circle553, _circle554, _circle555, _circle556, _circle557, _circle558, _circle559, _circle560, _circle561, _circle562, _circle563, _circle564, _circle565, _circle566, _circle567, _circle568, _circle569, _circle570, _circle571, _circle572, _circle573, _circle574, _circle575, _circle576, _circle577, _circle578, _circle579, _circle580, _circle581, _circle582, _circle583, _circle584, _circle585, _circle586, _circle587, _circle588, _circle589, _circle590, _circle591, _circle592, _circle593, _circle594, _circle595, _circle596, _circle597, _circle598, _circle599, _circle600, _circle601, _circle602, _circle603, _circle604, _circle605, _circle606, _circle607, _circle608, _circle609, _circle610, _circle611, _circle612, _circle613, _circle614, _circle615, _circle616, _circle617, _circle618, _circle619, _circle620, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _circle621, _circle622, _circle623, _circle624, _circle625, _circle626, _circle627, _circle628, _circle629, _circle630, _circle631, _circle632, _circle633, _circle634, _circle635, _circle636, _circle637, _circle638, _circle639, _circle640, _circle641, _circle642, _circle643, _circle644, _circle645, _circle646, _circle647, _circle648, _circle649, _circle650, _circle651, _circle652, _circle653, _circle654, _circle655, _circle656, _circle657, _circle658, _circle659, _circle660, _circle661, _circle662, _circle663, _circle664, _circle665, _circle666, _circle667, _circle668, _circle669, _circle670, _circle671, _circle672, _circle673, _circle674, _circle675, _circle676, _circle677, _circle678, _circle679, _circle680, _circle681, _circle682, _circle683, _circle684, _circle685, _circle686, _circle687, _circle688, _circle689, _circle690, _circle691, _circle692, _circle693, _circle694, _circle695, _circle696, _circle697, _circle698, _circle699, _circle700, _circle701, _circle702, _circle703, _circle704, _circle705, _circle706, _circle707, _circle708, _circle709, _circle710, _circle711, _circle712, _circle713, _circle714, _circle715, _circle716, _circle717, _circle718, _circle719, _circle720, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _circle721, _circle722, _circle723, _circle724, _circle725, _circle726, _circle727, _circle728, _path280, _circle729, _circle730, _circle731, _circle732, _circle733, _circle734, _circle735, _circle736, _circle737, _circle738, _circle739, _circle740, _circle741, _circle742, _circle743, _circle744, _circle745, _circle746, _circle747, _circle748, _circle749, _circle750, _circle751, _circle752, _circle753, _circle754, _circle755, _circle756, _circle757, _circle758, _circle759, _circle760, _circle761, _circle762, _circle763, _circle764, _circle765, _circle766, _circle767, _circle768, _circle769, _circle770, _circle771, _circle772, _circle773, _circle774, _circle775, _circle776, _circle777, _circle778, _circle779, _circle780, _circle781, _circle782, _circle783, _circle784, _circle785, _circle786, _circle787, _circle788, _circle789, _circle790, _circle791, _circle792, _circle793, _circle794, _circle795, _circle796, _circle797, _circle798, _circle799, _circle800, _circle801, _circle802, _circle803, _circle804, _circle805, _circle806, _circle807, _circle808, _circle809, _circle810, _circle811, _circle812, _circle813, _circle814, _circle815, _circle816, _circle817, _circle818, _circle819, _circle820, _circle821, _circle822, _circle823, _circle824, _circle825, _circle826, _circle827, _circle828, _circle829, _circle830, _path281, _g3, _g4, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _image, _path299, _circle831, _circle832, _circle833, _path300, _circle834, _circle835, _circle836, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAscendScrollingBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 13841.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient31);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient30);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient38);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient32);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient90);\n      }\n\n      .st16 {\n        fill: url(#linear-gradient91);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient61);\n      }\n\n      .st18 {\n        fill: url(#linear-gradient60);\n      }\n\n      .st19 {\n        fill: url(#linear-gradient62);\n      }\n\n      .st20 {\n        fill: url(#linear-gradient69);\n      }\n\n      .st21 {\n        fill: url(#linear-gradient65);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient68);\n      }\n\n      .st23 {\n        fill: url(#linear-gradient67);\n      }\n\n      .st24 {\n        fill: url(#linear-gradient64);\n      }\n\n      .st25 {\n        fill: url(#linear-gradient63);\n      }\n\n      .st26 {\n        fill: url(#linear-gradient66);\n      }\n\n      .st27 {\n        fill: url(#linear-gradient71);\n      }\n\n      .st28 {\n        fill: url(#linear-gradient70);\n      }\n\n      .st29 {\n        fill: url(#linear-gradient39);\n      }\n\n      .st30 {\n        fill: url(#linear-gradient34);\n      }\n\n      .st31 {\n        fill: url(#linear-gradient37);\n      }\n\n      .st32 {\n        fill: url(#linear-gradient35);\n      }\n\n      .st33 {\n        fill: url(#linear-gradient33);\n      }\n\n      .st34 {\n        fill: url(#linear-gradient36);\n      }\n\n      .st35 {\n        fill: url(#linear-gradient80);\n      }\n\n      .st36 {\n        fill: url(#linear-gradient81);\n      }\n\n      .st37 {\n        fill: url(#linear-gradient40);\n      }\n\n      .st38 {\n        fill: url(#linear-gradient41);\n      }\n\n      .st39 {\n        fill: url(#linear-gradient42);\n      }\n\n      .st40 {\n        fill: url(#linear-gradient46);\n      }\n\n      .st41 {\n        fill: url(#linear-gradient48);\n      }\n\n      .st42 {\n        fill: url(#linear-gradient43);\n      }\n\n      .st43 {\n        fill: url(#linear-gradient44);\n      }\n\n      .st44 {\n        fill: url(#linear-gradient47);\n      }\n\n      .st45 {\n        fill: url(#linear-gradient45);\n      }\n\n      .st46 {\n        fill: url(#linear-gradient49);\n      }\n\n      .st47 {\n        fill: url(#linear-gradient97);\n      }\n\n      .st48 {\n        fill: url(#linear-gradient98);\n      }\n\n      .st49 {\n        fill: url(#linear-gradient95);\n      }\n\n      .st50 {\n        fill: url(#linear-gradient99);\n      }\n\n      .st51 {\n        fill: url(#linear-gradient93);\n      }\n\n      .st52 {\n        fill: url(#linear-gradient96);\n      }\n\n      .st53 {\n        fill: url(#linear-gradient94);\n      }\n\n      .st54 {\n        fill: url(#linear-gradient92);\n      }\n\n      .st55 {\n        fill: url(#linear-gradient89);\n      }\n\n      .st56 {\n        fill: url(#linear-gradient88);\n      }\n\n      .st57 {\n        fill: url(#linear-gradient83);\n      }\n\n      .st58 {\n        fill: url(#linear-gradient85);\n      }\n\n      .st59 {\n        fill: url(#linear-gradient79);\n      }\n\n      .st60 {\n        fill: url(#linear-gradient87);\n      }\n\n      .st61 {\n        fill: url(#linear-gradient78);\n      }\n\n      .st62 {\n        fill: url(#linear-gradient77);\n      }\n\n      .st63 {\n        fill: url(#linear-gradient76);\n      }\n\n      .st64 {\n        fill: url(#linear-gradient84);\n      }\n\n      .st65 {\n        fill: url(#linear-gradient82);\n      }\n\n      .st66 {\n        fill: url(#linear-gradient86);\n      }\n\n      .st67 {\n        fill: url(#linear-gradient75);\n      }\n\n      .st68 {\n        fill: url(#linear-gradient73);\n      }\n\n      .st69 {\n        fill: url(#linear-gradient74);\n      }\n\n      .st70 {\n        fill: url(#linear-gradient72);\n      }\n\n      .st71 {\n        fill: url(#linear-gradient50);\n      }\n\n      .st72 {\n        fill: url(#linear-gradient51);\n      }\n\n      .st73 {\n        fill: url(#linear-gradient52);\n      }\n\n      .st74 {\n        fill: url(#linear-gradient59);\n      }\n\n      .st75 {\n        fill: url(#linear-gradient53);\n      }\n\n      .st76 {\n        fill: url(#linear-gradient56);\n      }\n\n      .st77 {\n        fill: url(#linear-gradient54);\n      }\n\n      .st78 {\n        fill: url(#linear-gradient57);\n      }\n\n      .st79 {\n        fill: url(#linear-gradient55);\n      }\n\n      .st80 {\n        fill: url(#linear-gradient58);\n      }\n\n      .st81 {\n        fill: url(#linear-gradient28);\n      }\n\n      .st82 {\n        fill: url(#linear-gradient29);\n      }\n\n      .st83 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st84 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st85 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st86 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st87 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st88 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st89 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st90 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st91 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st92 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st93 {\n        fill: url(#linear-gradient23);\n      }\n\n      .st94 {\n        fill: url(#linear-gradient22);\n      }\n\n      .st95 {\n        fill: url(#linear-gradient24);\n      }\n\n      .st96 {\n        fill: url(#linear-gradient25);\n      }\n\n      .st97 {\n        fill: url(#linear-gradient21);\n      }\n\n      .st98 {\n        fill: url(#linear-gradient20);\n      }\n\n      .st99 {\n        fill: url(#linear-gradient27);\n      }\n\n      .st100 {\n        fill: url(#linear-gradient26);\n      }\n\n      .st101 {\n        fill: #060101;\n      }\n\n      .st102 {\n        fill: url(#linear-gradient);\n      }\n\n      .st103 {\n        opacity: .7;\n      }\n\n      .st103, .st104, .st105, .st106, .st107, .st108 {\n        fill: #fff;\n      }\n\n      .st109 {\n        fill-opacity: .4;\n      }\n\n      .st109, .st110 {\n        fill: #f8f2ee;\n      }\n\n      .st111, .st106, .st107, .st108 {\n        isolation: isolate;\n      }\n\n      .st112 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st113 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st114 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st115 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st116 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st117 {\n        fill: url(#linear-gradient142);\n      }\n\n      .st118 {\n        fill: url(#linear-gradient143);\n      }\n\n      .st119 {\n        fill: url(#linear-gradient144);\n      }\n\n      .st120 {\n        fill: url(#linear-gradient153);\n      }\n\n      .st121 {\n        fill: url(#linear-gradient152);\n      }\n\n      .st122 {\n        fill: url(#linear-gradient145);\n      }\n\n      .st123 {\n        fill: url(#linear-gradient148);\n      }\n\n      .st124 {\n        fill: url(#linear-gradient149);\n      }\n\n      .st125 {\n        fill: url(#linear-gradient147);\n      }\n\n      .st126 {\n        fill: url(#linear-gradient146);\n      }\n\n      .st127 {\n        fill: url(#linear-gradient140);\n      }\n\n      .st128 {\n        fill: url(#linear-gradient141);\n      }\n\n      .st129 {\n        fill: url(#linear-gradient154);\n      }\n\n      .st130 {\n        fill: url(#linear-gradient151);\n      }\n\n      .st131 {\n        fill: url(#linear-gradient150);\n      }\n\n      .st132 {\n        fill: url(#linear-gradient105);\n      }\n\n      .st133 {\n        fill: url(#linear-gradient109);\n      }\n\n      .st134 {\n        fill: url(#linear-gradient106);\n      }\n\n      .st135 {\n        fill: url(#linear-gradient107);\n      }\n\n      .st136 {\n        fill: url(#linear-gradient100);\n      }\n\n      .st137 {\n        fill: url(#linear-gradient104);\n      }\n\n      .st138 {\n        fill: url(#linear-gradient108);\n      }\n\n      .st139 {\n        fill: url(#linear-gradient103);\n      }\n\n      .st140 {\n        fill: url(#linear-gradient102);\n      }\n\n      .st141 {\n        fill: url(#linear-gradient101);\n      }\n\n      .st142 {\n        fill: url(#linear-gradient116);\n      }\n\n      .st143 {\n        fill: url(#linear-gradient115);\n      }\n\n      .st144 {\n        fill: url(#linear-gradient118);\n      }\n\n      .st145 {\n        fill: url(#linear-gradient117);\n      }\n\n      .st146 {\n        fill: url(#linear-gradient119);\n      }\n\n      .st147 {\n        fill: url(#linear-gradient113);\n      }\n\n      .st148 {\n        fill: url(#linear-gradient112);\n      }\n\n      .st149 {\n        fill: url(#linear-gradient111);\n      }\n\n      .st150 {\n        fill: url(#linear-gradient114);\n      }\n\n      .st151 {\n        fill: url(#linear-gradient110);\n      }\n\n      .st152 {\n        fill: url(#linear-gradient127);\n      }\n\n      .st153 {\n        fill: url(#linear-gradient125);\n      }\n\n      .st154 {\n        fill: url(#linear-gradient128);\n      }\n\n      .st155 {\n        fill: url(#linear-gradient126);\n      }\n\n      .st156 {\n        fill: url(#linear-gradient129);\n      }\n\n      .st157 {\n        fill: url(#linear-gradient122);\n      }\n\n      .st158 {\n        fill: url(#linear-gradient121);\n      }\n\n      .st159 {\n        fill: url(#linear-gradient123);\n      }\n\n      .st160 {\n        fill: url(#linear-gradient124);\n      }\n\n      .st161 {\n        fill: url(#linear-gradient120);\n      }\n\n      .st162 {\n        fill: url(#linear-gradient133);\n      }\n\n      .st163 {\n        fill: url(#linear-gradient132);\n      }\n\n      .st164 {\n        fill: url(#linear-gradient134);\n      }\n\n      .st165 {\n        fill: url(#linear-gradient130);\n      }\n\n      .st166 {\n        fill: url(#linear-gradient136);\n      }\n\n      .st167 {\n        fill: url(#linear-gradient138);\n      }\n\n      .st168 {\n        fill: url(#linear-gradient139);\n      }\n\n      .st169 {\n        fill: url(#linear-gradient135);\n      }\n\n      .st170 {\n        fill: url(#linear-gradient137);\n      }\n\n      .st171 {\n        fill: url(#linear-gradient131);\n      }\n\n      .st1 {\n        stroke: #fff;\n        stroke-dasharray: 7.5 7.5;\n        stroke-width: 1.9px;\n      }\n\n      .st172 {\n        opacity: .4;\n      }\n\n      .st173, .st108 {\n        opacity: .4;\n      }\n\n      .st174, .st107 {\n        opacity: .5;\n      }\n\n      .st175, .st106 {\n        opacity: 0;\n      }\n\n      .st105 {\n        fill-opacity: .9;\n      }\n\n      .st176 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7140.5,
    y1: -581.8,
    x2: -7170.4,
    y2: -521.2,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -7467.1,
    y1: -1034.9,
    x2: -7508.5,
    y2: -931.7,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -7623.6,
    y1: 4324.6,
    x2: -7624.1,
    y2: 4348.1,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -7129.5,
    y1: 3885.6,
    x2: -7132.5,
    y2: 3907.1,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: -7178.8,
    y1: 3907.6,
    x2: -7179.8,
    y2: 3923.1,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: -7600.7,
    y1: 4013.3,
    x2: -7642.1,
    y2: 4116.5,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: -7654.3,
    y1: 3271,
    x2: -7649.7,
    y2: 3306.2,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: -7484.1,
    y1: 2788.1,
    x2: -7484.6,
    y2: 2811.6,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: -7111.2,
    y1: 799.3,
    x2: -7184.9,
    y2: 962.5,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: -7116.3,
    y1: 1714.5,
    x2: -7146.2,
    y2: 1775.1,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: -7304.1,
    y1: 588.1,
    x2: -7310.2,
    y2: 654.4,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: -7557.6,
    y1: 1095.9,
    x2: -7599,
    y2: 1199.1,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: -7188.4,
    y1: 1726.9,
    x2: -7207.5,
    y2: 1796.1,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: -7119.6,
    y1: 2913.3,
    x2: -7138.6,
    y2: 2982.5,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: -7562.2,
    y1: 1346.9,
    x2: -7565.2,
    y2: 1368.4,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: -7151.8,
    y1: 1595.6,
    x2: -7147.2,
    y2: 1630.8,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: -7154.2,
    y1: 2363.7,
    x2: -7154.6,
    y2: 2387.3,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: -7611.4,
    y1: 1368.9,
    x2: -7612.4,
    y2: 1384.4,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: -7123.5,
    y1: 203.6,
    x2: -7167.7,
    y2: 301.4,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 466,
    y: 5571.7,
    width: 208,
    height: 50
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: -7175.3,
    y1: -2206.8,
    x2: -7186.2,
    y2: -2145.4,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient20",
    x1: -7183.5,
    y1: -2203.6,
    x2: -7190.7,
    y2: -2179,
    gradientTransform: "translate(7747 7794.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 33.8,
    y: 3979.6,
    width: 245.6,
    height: 47.9,
    transform: "translate(-3822.7 3536.5) rotate(-81.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient21",
    x1: 127.3,
    y1: 9841.9,
    x2: 185.9,
    y2: 9832.4,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient22",
    x1: 146.2,
    y1: 9838.9,
    x2: 179.2,
    y2: 9833,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    xlinkHref: "#linear-gradient14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 593.6,
    y: 535.2,
    width: 69,
    height: 28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient23",
    x1: 632.2,
    y1: 13303.5,
    x2: 624.8,
    y2: 13280.8,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    xlinkHref: "#linear-gradient14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient24",
    x1: 624.8,
    y1: 13296.5,
    x2: 624.8,
    y2: 13294.8,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient25",
    x1: 621.7,
    y1: 13297.4,
    x2: 621.7,
    y2: 13295.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient26",
    x1: 618.7,
    y1: 13298.3,
    x2: 618.7,
    y2: 13296.5,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient27",
    x1: 615.7,
    y1: 13299.2,
    x2: 615.7,
    y2: 13297.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient28",
    x1: 612.7,
    y1: 13300.1,
    x2: 612.7,
    y2: 13298.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient29",
    x1: 609.7,
    y1: 13300.9,
    x2: 609.7,
    y2: 13299.2,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient30",
    x1: 606.8,
    y1: 13301.8,
    x2: 606.8,
    y2: 13300,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient31",
    x1: 603.8,
    y1: 13302.7,
    x2: 603.8,
    y2: 13300.9,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient32",
    x1: 600.8,
    y1: 13303.6,
    x2: 600.8,
    y2: 13301.8,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient33",
    x1: 597.8,
    y1: 13304.5,
    x2: 597.8,
    y2: 13302.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient34",
    x1: 596,
    y1: 13299.6,
    x2: 596,
    y2: 13297.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient35",
    x1: 596.8,
    y1: 13302,
    x2: 596.8,
    y2: 13300.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient36",
    x1: 599,
    y1: 13298.8,
    x2: 599,
    y2: 13296.8,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient37",
    x1: 599.8,
    y1: 13301.1,
    x2: 599.8,
    y2: 13299.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient38",
    x1: 602,
    y1: 13297.9,
    x2: 602,
    y2: 13295.9,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient39",
    x1: 602.8,
    y1: 13300.2,
    x2: 602.8,
    y2: 13298.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient40",
    x1: 605,
    y1: 13297,
    x2: 605,
    y2: 13295,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient41",
    x1: 605.8,
    y1: 13299.4,
    x2: 605.8,
    y2: 13297.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient42",
    x1: 608,
    y1: 13296.2,
    x2: 608,
    y2: 13294.2,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient43",
    x1: 609,
    y1: 13298.5,
    x2: 609,
    y2: 13296.8,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient44",
    x1: 610.9,
    y1: 13295.3,
    x2: 610.9,
    y2: 13293.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient45",
    x1: 612,
    y1: 13297.6,
    x2: 612,
    y2: 13296,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient46",
    x1: 613.9,
    y1: 13294.4,
    x2: 613.9,
    y2: 13292.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient47",
    x1: 615,
    y1: 13296.8,
    x2: 615,
    y2: 13295.1,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient48",
    x1: 616.9,
    y1: 13293.5,
    x2: 616.9,
    y2: 13291.5,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient49",
    x1: 618,
    y1: 13295.9,
    x2: 618,
    y2: 13294.2,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient50",
    x1: 619.9,
    y1: 13292.7,
    x2: 619.9,
    y2: 13290.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient51",
    x1: 620.9,
    y1: 13295,
    x2: 620.9,
    y2: 13293.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient52",
    x1: 623,
    y1: 13291.8,
    x2: 623,
    y2: 13289.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient53",
    x1: 624,
    y1: 13294.1,
    x2: 624,
    y2: 13292.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient54",
    x1: 634.1,
    y1: 13295.4,
    x2: 634.1,
    y2: 13291.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient55",
    x1: 635.1,
    y1: 13302.6,
    x2: 635.1,
    y2: 13295.2,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient56",
    x1: 631.2,
    y1: 13300.5,
    x2: 631.2,
    y2: 13296.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient57",
    x1: 629.1,
    y1: 13295.1,
    x2: 629.1,
    y2: 13286.8,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient58",
    x1: 633.6,
    y1: 13292.1,
    x2: 633.6,
    y2: 13284.2,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient59",
    x1: 658.2,
    y1: 13285,
    x2: 658.2,
    y2: 13283.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient60",
    x1: 657.2,
    y1: 13283.1,
    x2: 657.2,
    y2: 13281.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient61",
    x1: 655.9,
    y1: 13285.7,
    x2: 655.9,
    y2: 13284.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient62",
    x1: 654.8,
    y1: 13283.8,
    x2: 654.8,
    y2: 13282.1,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient63",
    x1: 653.5,
    y1: 13286.4,
    x2: 653.5,
    y2: 13285,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient64",
    x1: 652.5,
    y1: 13284.5,
    x2: 652.5,
    y2: 13282.8,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient65",
    x1: 651.2,
    y1: 13287.1,
    x2: 651.2,
    y2: 13285.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient66",
    x1: 650.1,
    y1: 13285.2,
    x2: 650.1,
    y2: 13283.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient67",
    x1: 648.9,
    y1: 13287.8,
    x2: 648.9,
    y2: 13286.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient68",
    x1: 647.8,
    y1: 13285.9,
    x2: 647.8,
    y2: 13284.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient69",
    x1: 646.5,
    y1: 13288.5,
    x2: 646.5,
    y2: 13287.1,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient70",
    x1: 645.5,
    y1: 13286.6,
    x2: 645.5,
    y2: 13285,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient71",
    x1: 644.2,
    y1: 13289.2,
    x2: 644.2,
    y2: 13287.9,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient72",
    x1: 643.1,
    y1: 13287.4,
    x2: 643.1,
    y2: 13285.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient73",
    x1: 641.9,
    y1: 13289.9,
    x2: 641.9,
    y2: 13288.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient74",
    x1: 640.8,
    y1: 13288,
    x2: 640.8,
    y2: 13286.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient75",
    x1: 639.7,
    y1: 13285.9,
    x2: 639.7,
    y2: 13284.3,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient76",
    x1: 642,
    y1: 13285.2,
    x2: 642,
    y2: 13283.6,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient77",
    x1: 644.4,
    y1: 13284.5,
    x2: 644.4,
    y2: 13282.9,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient78",
    x1: 646.7,
    y1: 13283.8,
    x2: 646.7,
    y2: 13282.2,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient79",
    x1: 649,
    y1: 13283.1,
    x2: 649,
    y2: 13281.5,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient80",
    x1: 651.4,
    y1: 13282.3,
    x2: 651.4,
    y2: 13280.8,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient81",
    x1: 653.7,
    y1: 13281.6,
    x2: 653.7,
    y2: 13280.1,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient82",
    x1: 656.1,
    y1: 13280.9,
    x2: 656.1,
    y2: 13279.4,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient83",
    x1: 658.4,
    y1: 13280.2,
    x2: 658.4,
    y2: 13278.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient84",
    x1: 659.5,
    y1: 13282.4,
    x2: 659.5,
    y2: 13280.7,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient85",
    x1: 660.5,
    y1: 13284.3,
    x2: 660.5,
    y2: 13282.9,
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 66.6,
    y: 1425,
    width: 69,
    height: 28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient86",
    x1: 106.3,
    y1: 12413.6,
    x2: 99,
    y2: 12391,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient87",
    x1: 98.9,
    y1: 12406.7,
    x2: 98.9,
    y2: 12404.9,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient88",
    x1: 95.8,
    y1: 12407.6,
    x2: 95.8,
    y2: 12405.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient89",
    x1: 92.9,
    y1: 12408.4,
    x2: 92.9,
    y2: 12406.7,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient90",
    x1: 89.9,
    y1: 12409.3,
    x2: 89.9,
    y2: 12407.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient91",
    x1: 86.9,
    y1: 12410.2,
    x2: 86.9,
    y2: 12408.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient92",
    x1: 83.9,
    y1: 12411.1,
    x2: 83.9,
    y2: 12409.3,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient93",
    x1: 80.9,
    y1: 12412,
    x2: 80.9,
    y2: 12410.2,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient94",
    x1: 77.9,
    y1: 12412.8,
    x2: 77.9,
    y2: 12411,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient95",
    x1: 74.9,
    y1: 12413.7,
    x2: 74.9,
    y2: 12411.9,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient96",
    x1: 72,
    y1: 12414.6,
    x2: 72,
    y2: 12412.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient97",
    x1: 70.2,
    y1: 12409.8,
    x2: 70.2,
    y2: 12407.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient98",
    x1: 71,
    y1: 12412.1,
    x2: 71,
    y2: 12410.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient99",
    x1: 73.1,
    y1: 12408.9,
    x2: 73.1,
    y2: 12406.9,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient100",
    x1: 73.9,
    y1: 12411.2,
    x2: 73.9,
    y2: 12409.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient101",
    x1: 76.1,
    y1: 12408,
    x2: 76.1,
    y2: 12406.1,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient102",
    x1: 76.9,
    y1: 12410.4,
    x2: 76.9,
    y2: 12408.7,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient103",
    x1: 79.1,
    y1: 12407.2,
    x2: 79.1,
    y2: 12405.2,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient104",
    x1: 79.9,
    y1: 12409.5,
    x2: 79.9,
    y2: 12407.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient105",
    x1: 82.1,
    y1: 12406.3,
    x2: 82.1,
    y2: 12404.3,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient106",
    x1: 83.1,
    y1: 12408.6,
    x2: 83.1,
    y2: 12407,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient107",
    x1: 85.1,
    y1: 12405.4,
    x2: 85.1,
    y2: 12403.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient108",
    x1: 86.1,
    y1: 12407.8,
    x2: 86.1,
    y2: 12406.1,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient109",
    x1: 88.1,
    y1: 12404.6,
    x2: 88.1,
    y2: 12402.5,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient110",
    x1: 89.1,
    y1: 12406.9,
    x2: 89.1,
    y2: 12405.2,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient111",
    x1: 91.1,
    y1: 12403.7,
    x2: 91.1,
    y2: 12401.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient112",
    x1: 92.1,
    y1: 12406,
    x2: 92.1,
    y2: 12404.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient113",
    x1: 94,
    y1: 12402.8,
    x2: 94,
    y2: 12400.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient114",
    x1: 95.1,
    y1: 12405.1,
    x2: 95.1,
    y2: 12403.5,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient115",
    x1: 97.1,
    y1: 12402,
    x2: 97.1,
    y2: 12399.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient116",
    x1: 98.2,
    y1: 12404.3,
    x2: 98.2,
    y2: 12402.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient117",
    x1: 108.3,
    y1: 12405.6,
    x2: 108.3,
    y2: 12401.7,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient118",
    x1: 109.2,
    y1: 12412.7,
    x2: 109.2,
    y2: 12405.3,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient119",
    x1: 105.4,
    y1: 12410.6,
    x2: 105.4,
    y2: 12406.5,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient120",
    x1: 103.2,
    y1: 12405.2,
    x2: 103.2,
    y2: 12397,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient121",
    x1: 107.7,
    y1: 12402.2,
    x2: 107.7,
    y2: 12394.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient122",
    x1: 132.4,
    y1: 12395.1,
    x2: 132.4,
    y2: 12393.7,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient123",
    x1: 131.3,
    y1: 12393.2,
    x2: 131.3,
    y2: 12391.5,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient124",
    x1: 130,
    y1: 12395.8,
    x2: 130,
    y2: 12394.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient125",
    x1: 129,
    y1: 12393.9,
    x2: 129,
    y2: 12392.3,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient126",
    x1: 127.7,
    y1: 12396.5,
    x2: 127.7,
    y2: 12395.2,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient127",
    x1: 126.6,
    y1: 12394.6,
    x2: 126.6,
    y2: 12393,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient128",
    x1: 125.3,
    y1: 12397.2,
    x2: 125.3,
    y2: 12395.9,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient129",
    x1: 124.3,
    y1: 12395.4,
    x2: 124.3,
    y2: 12393.7,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient130",
    x1: 123,
    y1: 12397.9,
    x2: 123,
    y2: 12396.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient131",
    x1: 122,
    y1: 12396.1,
    x2: 122,
    y2: 12394.4,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient132",
    x1: 120.7,
    y1: 12398.7,
    x2: 120.7,
    y2: 12397.3,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient133",
    x1: 119.6,
    y1: 12396.8,
    x2: 119.6,
    y2: 12395.1,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient134",
    x1: 118.3,
    y1: 12399.4,
    x2: 118.3,
    y2: 12398,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient135",
    x1: 117.3,
    y1: 12397.5,
    x2: 117.3,
    y2: 12395.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient136",
    x1: 116,
    y1: 12400.1,
    x2: 116,
    y2: 12398.7,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient137",
    x1: 115,
    y1: 12398.2,
    x2: 115,
    y2: 12396.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient138",
    x1: 113.9,
    y1: 12396,
    x2: 113.9,
    y2: 12394.5,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient139",
    x1: 116.2,
    y1: 12395.4,
    x2: 116.2,
    y2: 12393.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient140",
    x1: 118.5,
    y1: 12394.6,
    x2: 118.5,
    y2: 12393,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient141",
    x1: 120.9,
    y1: 12393.9,
    x2: 120.9,
    y2: 12392.3,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient142",
    x1: 123.2,
    y1: 12393.2,
    x2: 123.2,
    y2: 12391.6,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient143",
    x1: 125.5,
    y1: 12392.5,
    x2: 125.5,
    y2: 12390.9,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient144",
    x1: 127.9,
    y1: 12391.8,
    x2: 127.9,
    y2: 12390.2,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient145",
    x1: 130.2,
    y1: 12391,
    x2: 130.2,
    y2: 12389.5,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient146",
    x1: 132.5,
    y1: 12390.3,
    x2: 132.5,
    y2: 12388.8,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient147",
    x1: 133.6,
    y1: 12392.5,
    x2: 133.6,
    y2: 12390.9,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient148",
    x1: 134.7,
    y1: 12394.4,
    x2: 134.7,
    y2: 12393,
    gradientTransform: "translate(203.4 13840.7) rotate(-180)",
    xlinkHref: "#linear-gradient24"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 44.8,
    y: 9853.7,
    width: 220.2,
    height: 74.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient149",
    x1: 116.8,
    y1: 3886,
    x2: 172.3,
    y2: 4008.9,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f1ec",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f1ec",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient150",
    x1: 254.6,
    y1: 3975.2,
    x2: 167.6,
    y2: 3928.8,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f1ec",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f1ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient151",
    x1: 170.7,
    y1: 3935.3,
    x2: 153.3,
    y2: 3912.8,
    xlinkHref: "#linear-gradient150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient152",
    x1: 233.8,
    y1: 3930.8,
    x2: 259.2,
    y2: 3947,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f1ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f1ec",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 501.5,
    y: 1859.2,
    width: 106,
    height: 90
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient153",
    x1: 529.6,
    y1: 11988.7,
    x2: 570.6,
    y2: 11899,
    gradientTransform: "translate(0 13840.7) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f2ee",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f2ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient154",
    x1: 529.8,
    y1: 11930.9,
    x2: 534.6,
    y2: 11921.8,
    xlinkHref: "#linear-gradient153"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M23,1693.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M92,2124.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M327.6,1788.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M45.7,1814.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M350.7,2047.3l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M202.3,2091.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M257.6,2376.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M5.8,2090.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M246.1,2042.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8h0Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M266.6,2293.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M226.2,1825.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M4.6,2303.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8s.8-6.8.8-6.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M164.9,2246.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M247.6,1898.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M303,2184l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M26.1,2376.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M186.4,2319.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M126.4,1631l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M274.6,1963.8l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M330,2249l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M157.5,2030.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M164.5,2377.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M137.6,1813l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M76.3,2234.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M223.5,1775.8l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M3.5,1876.8l.6,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7s.7-4.4.7-4.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M308.5,2110l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M165.6,1876.8l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M220.9,2162.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M104.3,2297.9l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M48.9,2039.6l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4h0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M128.8,1972.3l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M346.5,2295.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M135.8,1708.5l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M204.5,2206.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M351,1617.3l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M247.7,1645.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M342.5,1842.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M121,2319.5l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 10.2,
    cy: 1788.3,
    r: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 315.1,
    cy: 2021.5,
    r: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 362.2,
    cy: 2329.9,
    r: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 59.5,
    cy: 1764.9,
    r: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 128.5,
    cy: 2196,
    r: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 364.5,
    cy: 1998,
    r: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 29,
    cy: 1952.7,
    r: 0.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 65,
    cy: 1907.3,
    r: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 369.9,
    cy: 2140.5,
    r: 0.8
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 26.6,
    cy: 2174.2,
    r: 0.8
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 155.2,
    cy: 2123.9,
    r: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 135.3,
    cy: 1906.8,
    r: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 190.6,
    cy: 2192.1,
    r: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 74,
    cy: 2327.9,
    r: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 41.5,
    cy: 1662.3,
    r: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 110.5,
    cy: 2093.5,
    r: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 90.6,
    cy: 1876.4,
    r: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 182.4,
    cy: 1647.4,
    r: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 330.6,
    cy: 1980.2,
    r: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 251.4,
    cy: 2078.6,
    r: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 306.8,
    cy: 2363.9,
    r: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 231.5,
    cy: 1861.5,
    r: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 9.9,
    cy: 2339,
    r: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 316.2,
    cy: 2152.9,
    r: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 277.2,
    cy: 1844.4,
    r: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 55.6,
    cy: 2321.9,
    r: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 215.9,
    cy: 2265.5,
    r: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 230.1,
    cy: 1689.7,
    r: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 324.9,
    cy: 1886.7,
    r: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 103.4,
    cy: 2364.2,
    r: 0.8
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 391.2,
    cy: 2397.9,
    r: 0.8
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 219.2,
    cy: 1964.4,
    r: 0.8
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 274.5,
    cy: 2249.8,
    r: 0.8
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 175.3,
    cy: 1943.3,
    r: 0.8
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 261.2,
    cy: 2232.9,
    r: 0.8
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 263,
    cy: 1839.2,
    r: 0.8
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 31.2,
    cy: 2266.9,
    r: 0.8
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 234.8,
    cy: 2161.7,
    r: 0.8
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 54.8,
    cy: 1563.7,
    r: 0.8
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 123.8,
    cy: 1994.9,
    r: 0.8
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 179.2,
    cy: 2280.2,
    r: 0.8
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 231.2,
    cy: 1739.9,
    r: 0.8
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 124.5,
    cy: 1883.1,
    r: 0.8
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 63.2,
    cy: 2304.1,
    r: 0.8
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 143.4,
    cy: 1764,
    r: 2
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 341.6,
    cy: 1686.6,
    r: 2
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 129.6,
    cy: 1580.5,
    r: 2,
    transform: "translate(-1453.4 1675.7) rotate(-88.8)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 277.8,
    cy: 1913.3,
    r: 2
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 333.1,
    cy: 2198.6,
    r: 2
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 56.2,
    cy: 2390.5,
    r: 2,
    transform: "translate(-2334.9 2408.4) rotate(-89.1)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 280.4,
    cy: 2140,
    r: 2
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 198.6,
    cy: 2011.7,
    r: 2
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 359.4,
    cy: 2380,
    r: 2
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 178.6,
    cy: 1794.6,
    r: 2
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 270.4,
    cy: 1539,
    r: 2
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 365.2,
    cy: 1736,
    r: 2
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 84.2,
    cy: 1657.2,
    r: 2
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 348.4,
    cy: 1943,
    r: 2
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 153.1,
    cy: 2088.4,
    r: 2
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 208.5,
    cy: 2373.7,
    r: 2
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 133.2,
    cy: 1871.3,
    r: 2
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 71.9,
    cy: 2292.4,
    r: 2
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 299.4,
    cy: 1566,
    r: 2
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 172.6,
    cy: 1950.8,
    r: 2
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 228,
    cy: 2236.1,
    r: 2
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 32.5,
    cy: 1583.7,
    r: 1.2,
    transform: "translate(-1551.3 1607.8) rotate(-89.7)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 101.5,
    cy: 2014.8,
    r: 1.2
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 81.6,
    cy: 1797.7,
    r: 1.2
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 136.2,
    cy: 1630.2,
    r: 0.8
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 284.4,
    cy: 1963,
    r: 0.8
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 339.8,
    cy: 2248.3,
    r: 0.8
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 205.2,
    cy: 2061.4,
    r: 0.8
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 260.6,
    cy: 2346.7,
    r: 0.8
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 185.3,
    cy: 1844.3,
    r: 0.8
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 124,
    cy: 2265.4,
    r: 0.8
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 343.1,
    cy: 1910.5,
    r: 0.8
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 121.6,
    cy: 2388,
    r: 0.8
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 263.9,
    cy: 2008.9,
    r: 0.8
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 319.3,
    cy: 2294.2,
    r: 0.8
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 244,
    cy: 1791.9,
    r: 0.8
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 289.7,
    cy: 1774.8,
    r: 0.8
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 201.6,
    cy: 1654.1,
    r: 1.2
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 349.8,
    cy: 1986.8,
    r: 1.2
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 270.6,
    cy: 2085.3,
    r: 1.2
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 325.9,
    cy: 2370.6,
    r: 1.2
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 250.6,
    cy: 1868.2,
    r: 1.2
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 43.6,
    cy: 2346.3,
    r: 1.2
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 189.4,
    cy: 2289.3,
    r: 1.2
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 296.4,
    cy: 1851.1,
    r: 1.2
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 8.6,
    cy: 2235.3,
    r: 1.2
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 142.1,
    cy: 1708.1,
    r: 1.2
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 211.1,
    cy: 2139.3,
    r: 1.2
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 366.6,
    cy: 1592.3,
    r: 1.2
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 147.6,
    cy: 1541.4,
    r: 1.2
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 87.3,
    cy: 1723.8,
    r: 1.2
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 156.3,
    cy: 2154.9,
    r: 1.2
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 302.5,
    cy: 1632.6,
    r: 1.2
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 22.3,
    cy: 1755.1,
    r: 1.2
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 91.3,
    cy: 2186.2,
    r: 1.2
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 327.3,
    cy: 1988.3,
    r: 1.2
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 61.6,
    cy: 2063.4,
    r: 1.2
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 14.6,
    cy: 1998.3,
    r: 1.2
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 287.8,
    cy: 1739.2,
    r: 1.2
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 376,
    cy: 1894.9,
    r: 0.8
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 322.6,
    cy: 1759.1,
    r: 0.8
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 193.3,
    cy: 1753.1,
    r: 0.8
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 262.3,
    cy: 2184.3,
    r: 0.8
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 298.2,
    cy: 1692.9,
    r: 0.8
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M23,2573.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M92,3004.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M232.8,2471.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M45.7,2694.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M350.7,2927.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M202.3,2971.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M5.8,2970.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M4.6,3183.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8s.8-6.8.8-6.8Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M247.6,2778.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M302.4,3064.1l.7,5.8,3.3.7-3.3.7-.7,5.8-.7-5.8-3.3-.7,3.3-.7.7-5.8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M26.1,3256.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M186.4,3199.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M126.4,2511l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M274.6,2843.7l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M330,3129l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M157.5,2910.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M137.6,2693l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M76.3,3114.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M223.5,2655.8l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M3.5,2756.8l.6,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6s.7-4.4.7-4.4Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M308.5,2990l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M165.6,2756.8l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M220.9,3042.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M48.9,2919.6l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M128.8,2852.3l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M135.8,2588.5l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M351,2497.3l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M247.7,2525.1l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M121,3199.5l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 10.2,
    cy: 2668.3,
    r: 0.8
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 315.1,
    cy: 2901.5,
    r: 0.8
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 362.2,
    cy: 3209.9,
    r: 0.8
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 59.5,
    cy: 2644.9,
    r: 0.8
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 128.5,
    cy: 3076,
    r: 0.8
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 364.5,
    cy: 2878,
    r: 0.8
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 29,
    cy: 2832.7,
    r: 0.8
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 65,
    cy: 2787.3,
    r: 0.8
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 369.9,
    cy: 3020.5,
    r: 0.8
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 26.6,
    cy: 3054.2,
    r: 0.8
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 155.2,
    cy: 3003.9,
    r: 0.8
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 135.3,
    cy: 2786.8,
    r: 0.8
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 190.6,
    cy: 3072.1,
    r: 0.8
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 41.5,
    cy: 2542.3,
    r: 0.8
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 110.5,
    cy: 2973.5,
    r: 0.8
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 90.6,
    cy: 2756.4,
    r: 0.8
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 182.4,
    cy: 2527.4,
    r: 0.8
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 251.4,
    cy: 2958.6,
    r: 0.8
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 306.8,
    cy: 3243.9,
    r: 0.8
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 231.5,
    cy: 2741.5,
    r: 0.8
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 9.9,
    cy: 3219,
    r: 0.8
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 316.2,
    cy: 3032.9,
    r: 0.8
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 277.2,
    cy: 2724.4,
    r: 0.8
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 55.6,
    cy: 3201.9,
    r: 0.8
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 215.9,
    cy: 3145.5,
    r: 0.8
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 230.1,
    cy: 2569.7,
    r: 0.8
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 324.9,
    cy: 2766.7,
    r: 0.8
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 103.4,
    cy: 3244.2,
    r: 0.8
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 363.2,
    cy: 3267.9,
    r: 0.8
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 219.2,
    cy: 2844.4,
    r: 0.8
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 274.5,
    cy: 3129.8,
    r: 0.8
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 175.3,
    cy: 2823.3,
    r: 0.8
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 261.2,
    cy: 3112.9,
    r: 0.8
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 263,
    cy: 2719.2,
    r: 0.8
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 31.2,
    cy: 3146.9,
    r: 0.8
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 234.8,
    cy: 3041.7,
    r: 0.8
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 54.8,
    cy: 2443.7,
    r: 0.8
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 123.8,
    cy: 2874.9,
    r: 0.8
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 179.2,
    cy: 3160.2,
    r: 0.8
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 231.2,
    cy: 2619.9,
    r: 0.8
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 124.5,
    cy: 2763.1,
    r: 0.8
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 63.2,
    cy: 3184.1,
    r: 0.8
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 62.2,
    cy: 2451.1,
    r: 2,
    transform: "translate(-2389.5 2484.9) rotate(-89.3)"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 143.4,
    cy: 2644,
    r: 2
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 341.6,
    cy: 2566.6,
    r: 2
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1.4,
    cy: 2456,
    r: 2,
    transform: "translate(-2454.7 2453.2) rotate(-89.9)"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 129.6,
    cy: 2460.5,
    r: 2,
    transform: "translate(-2333.2 2536.6) rotate(-88.8)"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 277.8,
    cy: 2793.3,
    r: 2
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 333.1,
    cy: 3078.6,
    r: 2
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 280.4,
    cy: 3020,
    r: 2
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 198.6,
    cy: 2891.7,
    r: 2
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 178.6,
    cy: 2674.6,
    r: 2
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 270.4,
    cy: 2419,
    r: 2
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 365.2,
    cy: 2616,
    r: 2
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 84.2,
    cy: 2537.2,
    r: 2
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 348.4,
    cy: 2823,
    r: 2
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 153.1,
    cy: 2968.4,
    r: 2
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 208.5,
    cy: 3253.7,
    r: 2
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 133.2,
    cy: 2751.3,
    r: 2
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 299.4,
    cy: 2446,
    r: 2
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 172.6,
    cy: 2830.8,
    r: 2
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 228,
    cy: 3116.1,
    r: 2
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 32.5,
    cy: 2463.6,
    r: 1.2,
    transform: "translate(-7.7 .1) rotate(-.2)"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 101.5,
    cy: 2894.8,
    r: 1.2
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 81.6,
    cy: 2677.7,
    r: 1.2
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 136.2,
    cy: 2510.2,
    r: 0.8
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 284.4,
    cy: 2843,
    r: 0.8
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 339.8,
    cy: 3128.3,
    r: 0.8
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 205.2,
    cy: 2941.4,
    r: 0.8
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 260.6,
    cy: 3226.7,
    r: 0.8
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 185.3,
    cy: 2724.3,
    r: 0.8
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 124,
    cy: 3145.4,
    r: 0.8
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 194.9,
    cy: 2457.8,
    r: 0.8
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 343.1,
    cy: 2790.5,
    r: 0.8
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 121.6,
    cy: 3268,
    r: 0.8
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 263.9,
    cy: 2888.9,
    r: 0.8
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 319.3,
    cy: 3174.2,
    r: 0.8
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 244,
    cy: 2671.9,
    r: 0.8
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 289.7,
    cy: 2654.8,
    r: 0.8
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 201.6,
    cy: 2534.1,
    r: 1.2
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 270.6,
    cy: 2965.3,
    r: 1.2
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 250.6,
    cy: 2748.2,
    r: 1.2
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 189.4,
    cy: 3169.3,
    r: 1.2
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 296.4,
    cy: 2731.1,
    r: 1.2
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 8.6,
    cy: 3115.2,
    r: 1.2
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 142.1,
    cy: 2588.1,
    r: 1.2
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 211.1,
    cy: 3019.3,
    r: 1.2
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 366.6,
    cy: 2472.3,
    r: 1.2
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 15.3,
    cy: 2422.9,
    r: 1.2
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 147.6,
    cy: 2421.4,
    r: 1.2
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 87.3,
    cy: 2603.8,
    r: 1.2
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 156.3,
    cy: 3034.9,
    r: 1.2
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 302.5,
    cy: 2512.6,
    r: 1.2
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 22.3,
    cy: 2635.1,
    r: 1.2
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 91.3,
    cy: 3066.2,
    r: 1.2
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 327.3,
    cy: 2868.2,
    r: 1.2
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 61.6,
    cy: 2943.4,
    r: 1.2
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 14.6,
    cy: 2878.2,
    r: 1.2
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 192.9,
    cy: 2422.2,
    r: 1.2
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 287.8,
    cy: 2619.2,
    r: 1.2
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 227.8,
    cy: 2442.1,
    r: 0.8
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 376,
    cy: 2774.9,
    r: 0.8
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 322.6,
    cy: 2639.1,
    r: 0.8
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 193.3,
    cy: 2633.1,
    r: 0.8
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 262.3,
    cy: 3064.3,
    r: 0.8
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 298.2,
    cy: 2572.9,
    r: 0.8
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M383,1601.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M452,2032.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M687.6,1696.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M405.7,1722.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M710.7,1955.3l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M562.3,1999.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M617.6,2284.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M365.8,1998.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M606.1,1950.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M447.6,1815.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M626.6,2201.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M586.2,1733.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M364.6,2211.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M524.9,2154.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M607.7,1806.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M663,2092l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M386.1,2284.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M546.4,2227.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M634.6,1871.8l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M690,2157l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M517.5,1938.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M524.5,2285.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M497.6,1721l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M436.3,2142.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M583.5,1683.8l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M363.5,1784.8l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M668.5,2018l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M525.5,1784.8l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M580.9,2070.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M464.3,2205.9l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M408.9,1947.6l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M488.8,1880.3l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M726.5,2208.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M495.8,1616.5l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M564.5,2114.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M702.5,1750.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M481,2227.5l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 370.2,
    cy: 1696.3,
    r: 0.8
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 675.1,
    cy: 1929.5,
    r: 0.8
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 722.2,
    cy: 2237.9,
    r: 0.8
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 419.5,
    cy: 1672.9,
    r: 0.8
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 488.5,
    cy: 2104,
    r: 0.8
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 724.5,
    cy: 1906,
    r: 0.8
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 389,
    cy: 1860.7,
    r: 0.8
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 425,
    cy: 1815.3,
    r: 0.8
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M729.9,2047.7c.4,0,.8.4.8.8s-.3.8-.8.8-.8-.4-.8-.8.3-.8.8-.8Z"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 386.6,
    cy: 2082.2,
    r: 0.8
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 515.2,
    cy: 2031.9,
    r: 0.8
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 495.3,
    cy: 1814.8,
    r: 0.8
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 550.6,
    cy: 2100.1,
    r: 0.8
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 434,
    cy: 2235.9,
    r: 0.8
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 401.5,
    cy: 1570.3,
    r: 0.8
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 470.5,
    cy: 2001.5,
    r: 0.8
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 450.6,
    cy: 1784.4,
    r: 0.8
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 542.4,
    cy: 1555.4,
    r: 0.8
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 690.6,
    cy: 1888.2,
    r: 0.8
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 611.4,
    cy: 1986.6,
    r: 0.8
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 666.8,
    cy: 2271.9,
    r: 0.8
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 591.5,
    cy: 1769.5,
    r: 0.8
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 369.9,
    cy: 2247,
    r: 0.8
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 676.2,
    cy: 2060.9,
    r: 0.8
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 637.2,
    cy: 1752.4,
    r: 0.8
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 415.6,
    cy: 2229.9,
    r: 0.8
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 575.9,
    cy: 2173.5,
    r: 0.8
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 590.1,
    cy: 1597.7,
    r: 0.8
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 684.9,
    cy: 1794.7,
    r: 0.8
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 463.4,
    cy: 2272.2,
    r: 0.8
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 723.2,
    cy: 2295.9,
    r: 0.8
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 579.2,
    cy: 1872.4,
    r: 0.8
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 634.5,
    cy: 2157.8,
    r: 0.8
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 535.3,
    cy: 1851.3,
    r: 0.8
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 621.2,
    cy: 2140.9,
    r: 0.8
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 623,
    cy: 1747.2,
    r: 0.8
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 391.2,
    cy: 2174.9,
    r: 0.8
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 594.8,
    cy: 2069.7,
    r: 0.8
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 483.8,
    cy: 1902.9,
    r: 0.8
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 539.2,
    cy: 2188.2,
    r: 0.8
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 591.2,
    cy: 1647.9,
    r: 0.8
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 484.5,
    cy: 1791.1,
    r: 0.8
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 423.2,
    cy: 2212.1,
    r: 0.8
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 687.3,
    cy: 2116,
    r: 2
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 503.4,
    cy: 1672,
    r: 2
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 637.8,
    cy: 1821.3,
    r: 2
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 722.3,
    cy: 2088,
    r: 2
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 416.2,
    cy: 2298.7,
    r: 2
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 640.3,
    cy: 2048,
    r: 2
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 558.5,
    cy: 1919.7,
    r: 2
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 719.3,
    cy: 2288,
    r: 2
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 538.6,
    cy: 1702.6,
    r: 2
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 725.2,
    cy: 1644,
    r: 2
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 708.3,
    cy: 1851,
    r: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M513.2,1994.4c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Z"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 568.5,
    cy: 2281.7,
    r: 2
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 493.2,
    cy: 1779.3,
    r: 2
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 432,
    cy: 2200.4,
    r: 2
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 532.6,
    cy: 1858.8,
    r: 2
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 452.4,
    cy: 1859,
    r: 2
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 588,
    cy: 2144.1,
    r: 2
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 461.5,
    cy: 1922.8,
    r: 1.2
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 441.6,
    cy: 1705.7,
    r: 1.2
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 644.4,
    cy: 1871,
    r: 0.8
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 699.8,
    cy: 2156.3,
    r: 0.8
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 565.2,
    cy: 1969.4,
    r: 0.8
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 620.6,
    cy: 2254.7,
    r: 0.8
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 545.3,
    cy: 1752.3,
    r: 0.8
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 484,
    cy: 2173.4,
    r: 0.8
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 703.1,
    cy: 1818.5,
    r: 0.8
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 481.6,
    cy: 2296,
    r: 0.8
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 623.9,
    cy: 1916.9,
    r: 0.8
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 679.3,
    cy: 2202.2,
    r: 0.8
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604,
    cy: 1699.9,
    r: 0.8
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 649.7,
    cy: 1682.8,
    r: 0.8
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 709.8,
    cy: 1894.8,
    r: 1.2
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 630.6,
    cy: 1993.3,
    r: 1.2
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 685.9,
    cy: 2278.6,
    r: 1.2
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 610.6,
    cy: 1776.2,
    r: 1.2
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 403.6,
    cy: 2254.3,
    r: 1.2
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 549.4,
    cy: 2197.3,
    r: 1.2
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 656.4,
    cy: 1759.1,
    r: 1.2
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 368.6,
    cy: 2143.3,
    r: 1.2
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 502.1,
    cy: 1616.1,
    r: 1.2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M571.1,2046.1c.6,0,1.2.5,1.2,1.2s-.5,1.2-1.2,1.2-1.2-.5-1.2-1.2.5-1.2,1.2-1.2Z"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 410.6,
    cy: 1843.3,
    r: 1.2
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 447.3,
    cy: 1631.8,
    r: 1.2
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 516.3,
    cy: 2062.9,
    r: 1.2
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 382.3,
    cy: 1663.1,
    r: 1.2
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 451.3,
    cy: 2094.2,
    r: 1.2
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 687.3,
    cy: 1896.3,
    r: 1.2
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 421.6,
    cy: 1971.3,
    r: 1.2
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 374.6,
    cy: 1906.3,
    r: 1.2
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 647.8,
    cy: 1647.2,
    r: 1.2
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 736,
    cy: 1802.9,
    r: 0.8
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 682.6,
    cy: 1667.1,
    r: 0.8
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 553.3,
    cy: 1661.1,
    r: 0.8
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 622.3,
    cy: 2092.3,
    r: 0.8
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M383,2474.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M452,2905.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M592.8,2372.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M687.6,2569.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M405.7,2595.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M710.7,2828.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M562.3,2872.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M365.8,2871.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M606.1,2823.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M626.6,3074.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M586.2,2606.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M524.9,3027.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M386.1,3157.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M546.4,3100.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M486.4,2412l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M634.6,2744.7l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M690,3030l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M517.5,2811.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M497.6,2594l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M436.3,3015.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M363.5,2657.8l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M668.5,2891l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M580.9,2943.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M408.9,2820.6l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M726.5,3081.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M495.8,2489.5l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M564.5,2987.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M711,2398.3l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M607.7,2426.1l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M702.5,2623.1l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 370.2,
    cy: 2569.3,
    r: 0.8
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 675.1,
    cy: 2802.5,
    r: 0.8
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 722.2,
    cy: 3110.9,
    r: 0.8
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 419.5,
    cy: 2545.9,
    r: 0.8
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 488.5,
    cy: 2977,
    r: 0.8
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 724.5,
    cy: 2779,
    r: 0.8
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 389,
    cy: 2733.7,
    r: 0.8
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 425,
    cy: 2688.3,
    r: 0.8
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 729.9,
    cy: 2921.5,
    r: 0.8
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 386.6,
    cy: 2955.2,
    r: 0.8
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 515.2,
    cy: 2904.9,
    r: 0.8
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 495.3,
    cy: 2687.8,
    r: 0.8
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 550.6,
    cy: 2973.1,
    r: 0.8
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 401.5,
    cy: 2443.3,
    r: 0.8
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 470.5,
    cy: 2874.5,
    r: 0.8
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 450.6,
    cy: 2657.4,
    r: 0.8
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 542.4,
    cy: 2428.4,
    r: 0.8
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 690.6,
    cy: 2761.2,
    r: 0.8
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 611.4,
    cy: 2859.6,
    r: 0.8
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 666.8,
    cy: 3144.9,
    r: 0.8
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 591.5,
    cy: 2642.5,
    r: 0.8
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 369.9,
    cy: 3120,
    r: 0.8
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 676.2,
    cy: 2933.9,
    r: 0.8
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 637.2,
    cy: 2625.4,
    r: 0.8
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 415.6,
    cy: 3102.9,
    r: 0.8
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 575.9,
    cy: 3046.5,
    r: 0.8
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 590.1,
    cy: 2470.7,
    r: 0.8
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 684.9,
    cy: 2667.7,
    r: 0.8
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 463.4,
    cy: 3145.2,
    r: 0.8
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 723.2,
    cy: 3168.9,
    r: 0.8
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 579.2,
    cy: 2745.4,
    r: 0.8
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 634.5,
    cy: 3030.8,
    r: 0.8
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 535.3,
    cy: 2724.3,
    r: 0.8
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 621.2,
    cy: 3013.9,
    r: 0.8
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 623,
    cy: 2620.2,
    r: 0.8
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 391.2,
    cy: 3047.9,
    r: 0.8
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 594.8,
    cy: 2942.7,
    r: 0.8
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 414.8,
    cy: 2344.7,
    r: 0.8
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 483.8,
    cy: 2775.9,
    r: 0.8
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 539.2,
    cy: 3061.2,
    r: 0.8
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 484.5,
    cy: 2664.1,
    r: 0.8
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 713.3,
    cy: 2982,
    r: 2
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 503.4,
    cy: 2545,
    r: 2
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 701.6,
    cy: 2467.6,
    r: 2
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 362.8,
    cy: 2324.7,
    r: 2
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 489.5,
    cy: 2361.5,
    r: 2
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 637.8,
    cy: 2694.3,
    r: 2
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 416.2,
    cy: 3171.7,
    r: 2
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 640.3,
    cy: 2921,
    r: 2
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 558.5,
    cy: 2792.7,
    r: 2
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 719.3,
    cy: 3161,
    r: 2
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 630.4,
    cy: 2320,
    r: 2
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 725.2,
    cy: 2517,
    r: 2
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 444.1,
    cy: 2438.2,
    r: 2
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 708.3,
    cy: 2724,
    r: 2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M513.2,2867.4c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Z"
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 568.5,
    cy: 3154.7,
    r: 2
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 493.2,
    cy: 2652.3,
    r: 2
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 432,
    cy: 3073.4,
    r: 2
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 659.3,
    cy: 2347,
    r: 2
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 532.6,
    cy: 2731.8,
    r: 2
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 452.4,
    cy: 2732,
    r: 2
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 588,
    cy: 3017.1,
    r: 2
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 392.5,
    cy: 2364.6,
    r: 1.2
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 461.5,
    cy: 2795.8,
    r: 1.2
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 441.6,
    cy: 2578.7,
    r: 1.2
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 496.2,
    cy: 2411.2,
    r: 0.8
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 644.4,
    cy: 2744,
    r: 0.8
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 699.8,
    cy: 3029.3,
    r: 0.8
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 565.2,
    cy: 2842.4,
    r: 0.8
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 620.6,
    cy: 3127.7,
    r: 0.8
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 545.3,
    cy: 2625.3,
    r: 0.8
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 484,
    cy: 3046.4,
    r: 0.8
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 554.9,
    cy: 2358.8,
    r: 0.8
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 703.1,
    cy: 2691.5,
    r: 0.8
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 481.6,
    cy: 3169,
    r: 0.8
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 623.9,
    cy: 2789.9,
    r: 0.8
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 679.3,
    cy: 3075.2,
    r: 0.8
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604,
    cy: 2572.9,
    r: 0.8
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 649.7,
    cy: 2555.8,
    r: 0.8
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 561.6,
    cy: 2435.1,
    r: 1.2
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 709.8,
    cy: 2767.8,
    r: 1.2
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 630.6,
    cy: 2866.3,
    r: 1.2
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 685.9,
    cy: 3151.6,
    r: 1.2
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 610.6,
    cy: 2649.2,
    r: 1.2
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 403.6,
    cy: 3127.2,
    r: 1.2
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 549.4,
    cy: 3070.3,
    r: 1.2
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 656.4,
    cy: 2632.1,
    r: 1.2
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 368.6,
    cy: 3016.2,
    r: 1.2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M511.6,2466.1c.6,0,1.2.5,1.2,1.2s-.5,1.2-1.2,1.2-1.2-.5-1.2-1.2.5-1.2,1.2-1.2Z"
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 571.1,
    cy: 2920.3,
    r: 1.2
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 410.6,
    cy: 2716.2,
    r: 1.2
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 726.6,
    cy: 2373.3,
    r: 1.2
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 507.5,
    cy: 2322.4,
    r: 1.2
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 447.3,
    cy: 2504.8,
    r: 1.2
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 516.3,
    cy: 2935.9,
    r: 1.2
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 662.5,
    cy: 2413.6,
    r: 1.2
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 382.3,
    cy: 2536.1,
    r: 1.2
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 451.3,
    cy: 2967.2,
    r: 1.2
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 687.3,
    cy: 2769.2,
    r: 1.2
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 352.6,
    cy: 2413.2,
    r: 1.2
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 421.6,
    cy: 2844.4,
    r: 1.2
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 374.6,
    cy: 2779.2,
    r: 1.2
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 553,
    cy: 2323.2,
    r: 1.2
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 647.8,
    cy: 2520.2,
    r: 1.2
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 587.8,
    cy: 2343.1,
    r: 0.8
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 736,
    cy: 2675.9,
    r: 0.8
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 682.6,
    cy: 2540.1,
    r: 0.8
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 622.3,
    cy: 2965.3,
    r: 0.8
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 658.2,
    cy: 2473.9,
    r: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M33,3452.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M102,3883.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M242.8,3350.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M337.6,3547.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M55.7,3573.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M360.7,3806.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M212.3,3850.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M15.8,3849.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M256.1,3801.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M236.2,3584.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M14.6,4062.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M174.9,4005.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M257.6,3657.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M313,3943l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M136.4,3390l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M284.6,3722.7l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M340,4008l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M167.5,3789.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M147.6,3572l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M233.5,3534.8l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M13.5,3635.8l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6s.6-4.4.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M318.5,3869l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M175.6,3635.8l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M114.3,4056.9l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M58.9,3798.6l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M138.8,3731.3l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M376.5,4059.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M145.8,3467.5l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M361,3376.3l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M257.7,3404.1l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M352.5,3601.1l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 20.2,
    cy: 3547.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 325.1,
    cy: 3780.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 372.2,
    cy: 4088.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 69.5,
    cy: 3523.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 138.5,
    cy: 3955,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 374.5,
    cy: 3757,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 39,
    cy: 3711.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 75,
    cy: 3666.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 379.9,
    cy: 3899.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 36.6,
    cy: 3933.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 165.2,
    cy: 3882.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 145.3,
    cy: 3665.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 200.6,
    cy: 3951.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 84,
    cy: 4086.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 51.5,
    cy: 3421.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 120.5,
    cy: 3852.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 100.6,
    cy: 3635.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 192.4,
    cy: 3406.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 261.4,
    cy: 3837.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 316.8,
    cy: 4122.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 241.5,
    cy: 3620.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 19.9,
    cy: 4098,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 326.2,
    cy: 3911.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 287.2,
    cy: 3603.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 65.6,
    cy: 4080.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 225.9,
    cy: 4024.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 240.1,
    cy: 3448.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 334.9,
    cy: 3645.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 113.4,
    cy: 4123.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 373.2,
    cy: 4146.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 229.2,
    cy: 3723.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 284.5,
    cy: 4008.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 185.3,
    cy: 3702.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 271.2,
    cy: 3991.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 273,
    cy: 3598.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 41.2,
    cy: 4025.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 244.8,
    cy: 3920.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 64.8,
    cy: 3322.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 133.8,
    cy: 3753.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 189.2,
    cy: 4039.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 241.2,
    cy: 3498.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 134.5,
    cy: 3642.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 73.2,
    cy: 4063.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 72.2,
    cy: 3330.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 153.4,
    cy: 3523,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 351.6,
    cy: 3445.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 12.8,
    cy: 3302.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 139.6,
    cy: 3339.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 287.8,
    cy: 3672.3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 343.1,
    cy: 3957.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 290.4,
    cy: 3899,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 208.6,
    cy: 3770.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 188.6,
    cy: 3553.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 280.4,
    cy: 3298,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 375.2,
    cy: 3495,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 94.2,
    cy: 3416.2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 358.4,
    cy: 3702,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 163.1,
    cy: 3847.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 218.5,
    cy: 4092.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 143.2,
    cy: 3630.3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 309.4,
    cy: 3325,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 182.6,
    cy: 3709.8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 238,
    cy: 3995.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 42.5,
    cy: 3342.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 111.5,
    cy: 3773.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 91.6,
    cy: 3556.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 146.2,
    cy: 3389.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 294.4,
    cy: 3722,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 215.2,
    cy: 3820.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 285.2,
    cy: 4060.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 195.3,
    cy: 3603.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 204.9,
    cy: 3336.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 353.1,
    cy: 3669.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 273.9,
    cy: 3767.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 329.3,
    cy: 4053.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 254,
    cy: 3550.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 299.7,
    cy: 3533.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 211.6,
    cy: 3413.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 280.6,
    cy: 3844.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 260.6,
    cy: 3627.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 76.6,
    cy: 4022.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 199.4,
    cy: 4048.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 306.4,
    cy: 3610.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 152.1,
    cy: 3467.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 221.1,
    cy: 3898.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 376.6,
    cy: 3351.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 25.3,
    cy: 3301.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 157.6,
    cy: 3300.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 97.3,
    cy: 3482.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 166.3,
    cy: 3913.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 312.5,
    cy: 3391.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 32.3,
    cy: 3514.1,
    r: 1.2,
    transform: "translate(-10.9 .1) rotate(-.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 101.3,
    cy: 3945.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 337.3,
    cy: 3747.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 2.6,
    cy: 3391.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 71.6,
    cy: 3822.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 24.6,
    cy: 3757.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 202.9,
    cy: 3301.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 297.8,
    cy: 3498.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 237.8,
    cy: 3321.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 386,
    cy: 3653.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 332.6,
    cy: 3518.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 203.3,
    cy: 3512.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 272.3,
    cy: 3943.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 308.2,
    cy: 3451.9,
    r: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M396,3349.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M465,3780.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M605.8,3247.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M700.6,3444.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M418.7,3470.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M723.7,3703.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M575.3,3747.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M378.8,3746.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M619.1,3698.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M599.2,3481.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M537.9,3902.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M620.7,3554.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M676,3840l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M399.1,4032.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M559.4,3975.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M499.4,3287l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M703,3905l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M530.5,3686.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M537.5,4033.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M510.6,3469l.6,4.4,4.4.7-4.4.6-.6,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M449.3,3890.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M596.5,3431.8l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M376.5,3532.8l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M681.5,3766l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M538.5,3532.8l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M593.9,3818.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M477.3,3953.9l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M421.9,3695.6l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M501.8,3628.3l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M448.5,3601.1l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M739.5,3956.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M508.8,3364.5l.6,4.4,4.4.7-4.4.6-.6,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M577.5,3862.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M724,3273.3l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M620.7,3301.1l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M715.5,3498.1l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M650.5,3615.1l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 383.2,
    cy: 3444.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 688.1,
    cy: 3677.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 735.2,
    cy: 3985.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 432.5,
    cy: 3420.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 501.5,
    cy: 3852,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 737.5,
    cy: 3654,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 402,
    cy: 3608.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 438,
    cy: 3563.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 399.6,
    cy: 3830.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 528.2,
    cy: 3779.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 508.3,
    cy: 3562.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 563.6,
    cy: 3848.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 447,
    cy: 3983.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 414.5,
    cy: 3318.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 483.5,
    cy: 3749.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 463.6,
    cy: 3532.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 555.4,
    cy: 3303.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 624.4,
    cy: 3734.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 679.8,
    cy: 4019.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604.5,
    cy: 3517.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 382.9,
    cy: 3995,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 689.2,
    cy: 3808.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 650.2,
    cy: 3500.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 428.6,
    cy: 3977.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 588.9,
    cy: 3921.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 603.1,
    cy: 3345.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 697.9,
    cy: 3542.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 476.4,
    cy: 4020.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 736.2,
    cy: 4043.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 592.2,
    cy: 3620.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 647.5,
    cy: 3905.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 548.3,
    cy: 3599.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 634.2,
    cy: 3888.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 636,
    cy: 3495.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 404.2,
    cy: 3922.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 607.8,
    cy: 3817.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 427.8,
    cy: 3219.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 496.8,
    cy: 3650.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 552.2,
    cy: 3936.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604.2,
    cy: 3395.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 497.5,
    cy: 3539.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 466.2,
    cy: 3588.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 436.2,
    cy: 3960.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 435.2,
    cy: 3227.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 700.3,
    cy: 3864,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 516.3,
    cy: 3420,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 714.6,
    cy: 3342.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 502.5,
    cy: 3236.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 650.8,
    cy: 3569.3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 706.1,
    cy: 3854.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 429.2,
    cy: 4046.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 653.3,
    cy: 3796,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 571.5,
    cy: 3667.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 732.3,
    cy: 4036,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 551.6,
    cy: 3450.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 643.4,
    cy: 3195,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 738.2,
    cy: 3392,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 457.1,
    cy: 3313.2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 721.3,
    cy: 3599,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 526.2,
    cy: 3744.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 581.5,
    cy: 4029.7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 506.2,
    cy: 3527.3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 445,
    cy: 3948.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 672.3,
    cy: 3222,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 545.6,
    cy: 3606.8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 601,
    cy: 3892.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 405.5,
    cy: 3239.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 474.5,
    cy: 3670.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 454.6,
    cy: 3453.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 509.2,
    cy: 3286.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 712.8,
    cy: 3904.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 578.2,
    cy: 3717.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 633.6,
    cy: 4002.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 558.3,
    cy: 3500.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 497,
    cy: 3921.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 567.9,
    cy: 3233.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 716.1,
    cy: 3566.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 636.9,
    cy: 3664.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 692.3,
    cy: 3950.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 617,
    cy: 3447.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 662.7,
    cy: 3430.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 574.6,
    cy: 3310.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 643.6,
    cy: 3741.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 698.9,
    cy: 4026.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 623.6,
    cy: 3524.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 416.6,
    cy: 4002.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 562.4,
    cy: 3945.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 669.4,
    cy: 3507.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 381.6,
    cy: 3891.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M643,4265.7l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M730.3,4087.4l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M570.1,4143.8l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M431.9,4206.5l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M405,4141.4l-.6-4.4-4.4-.7,4.4-.6.6-4.4.6,4.4,4.4.6-4.4.7-.6,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M426.5,4280.5l-.6-4.4-4.4-.7,4.4-.6.6-4.4.6,4.4,4.4.6-4.4.7-.6,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M630.7,4092.6l-.7-4.4-4.4-.6,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.6-.7,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M368.5,4090.4l-.6-4.4-4.4-.7,4.4-.6.6-4.4.6,4.4,4.4.6-4.4.7-.6,4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 372.8,
    cy: 4060.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 606.5,
    cy: 4194.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 365,
    cy: 4250,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 708.3,
    cy: 4216.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 579.8,
    cy: 4266.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 544.3,
    cy: 4198.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 661,
    cy: 4062.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 428.2,
    cy: 4026.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 725.1,
    cy: 4051.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 418.8,
    cy: 4237.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 679.3,
    cy: 4068.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 519.1,
    cy: 4124.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 631.6,
    cy: 4026.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 371.8,
    cy: 4002.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 460.4,
    cy: 4140.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 473.8,
    cy: 4157.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 703.8,
    cy: 4123.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 500.1,
    cy: 4228.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 555.8,
    cy: 4110.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 671.8,
    cy: 4086.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 401.8,
    cy: 4191.9,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 454.6,
    cy: 4250.4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 526.4,
    cy: 4056.8,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 507,
    cy: 4154.4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 459.8,
    cy: 4088.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M415.7,4095.4c.4,0,.8.3.8.8s-.3.8-.8.8-.8-.3-.8-.8.3-.8.8-.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 668.4,
    cy: 4127.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 545.6,
    cy: 4101.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 523.9,
    cy: 4251.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 578.7,
    cy: 4235.5,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 643.7,
    cy: 4204.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 472.6,
    cy: 4206.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M207.1,4246.8l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M345.9,4117.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M185.6,4173.7l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M42,4244.4l-.7-4.4-4.4-.7,4.4-.6.7-4.4.7,4.4,4.4.6-4.4.7-.7,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M207.5,4116.4l-.6-4.4-4.4-.7,4.4-.6.6-4.4.7,4.4,4.4.6-4.4.7-.7,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M295.7,4259.4l-.6-4.4-4.4-.7,4.4-.6.6-4.4.6,4.4,4.4.6-4.4.7-.6,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M267.7,4195.6l-.6-4.4-4.4-.6,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.6-.6,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M5.5,4193.4l-.7-4.4-4.4-.7,4.4-.6.7-4.4.7,4.4,4.4.6-4.4.7-.7,4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 9.8,
    cy: 4163.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 298,
    cy: 4165.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 65.2,
    cy: 4129.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 362.1,
    cy: 4154.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 316.3,
    cy: 4171.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 156.1,
    cy: 4227.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 268.6,
    cy: 4129.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 8.8,
    cy: 4105.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 97.4,
    cy: 4243.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 110.8,
    cy: 4260.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 340.8,
    cy: 4226.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 192.8,
    cy: 4213.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 308.8,
    cy: 4189.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 315.8,
    cy: 4102.8,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 12.6,
    cy: 4113.4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 163.4,
    cy: 4119.8,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 300,
    cy: 4201.1,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 144,
    cy: 4257.4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 32.2,
    cy: 4245.2,
    r: 0.8,
    transform: "translate(-4.7 0) rotate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 111.4,
    cy: 4146.8,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 248,
    cy: 4228.1,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 52.7,
    cy: 4199.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 46,
    cy: 4122.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 328.4,
    cy: 4147.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 182.6,
    cy: 4204.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 363.4,
    cy: 4258.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M722.7,4533l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M623.1,4538.2l-.7-4.4-4.4-.6,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.6-.7,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M360.9,4536l-.6-4.4-4.4-.7,4.4-.6.6-4.4.6,4.4,4.4.6-4.4.7-.6,4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 365.2,
    cy: 4506.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 653.4,
    cy: 4508.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 420.6,
    cy: 4472.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 717.5,
    cy: 4497.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 671.7,
    cy: 4514.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 624,
    cy: 4471.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 364.2,
    cy: 4448.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 548.2,
    cy: 4555.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 664.2,
    cy: 4531.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 518.8,
    cy: 4502.4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 452.2,
    cy: 4534.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 408.1,
    cy: 4541.8,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 538,
    cy: 4546.8,
    r: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M338.3,4562.9l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M199.9,4562l-.6-4.4-4.4-.7,4.4-.6.6-4.4.7,4.4,4.4.6-4.4.7-.7,4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 1.2,
    cy: 4551.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 308.2,
    cy: 4548.4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 5,
    cy: 4559,
    r: 2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 155.8,
    cy: 4565.4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M94.4,4329.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M7,4507.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8s.8-6.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M167.3,4451.3l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M305.4,4388.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M332.4,4453.6l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M310.9,4314.6l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M106.7,4502.5l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M368.9,4504.7l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 364.6,
    cy: 4534.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 130.9,
    cy: 4400.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 372.3,
    cy: 4345.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 29,
    cy: 4378.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 157.6,
    cy: 4328.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 193,
    cy: 4396.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 76.4,
    cy: 4532.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 12.3,
    cy: 4543.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 318.6,
    cy: 4357.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 58,
    cy: 4526.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 218.3,
    cy: 4470.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 276.9,
    cy: 4454.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 263.6,
    cy: 4437.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 33.6,
    cy: 4471.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 237.2,
    cy: 4366.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 181.6,
    cy: 4484.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 65.6,
    cy: 4508.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 335.5,
    cy: 4403.1,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 282.7,
    cy: 4344.6,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 210.9,
    cy: 4538.3,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 230.4,
    cy: 4440.6,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 277.6,
    cy: 4506.5,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 321.7,
    cy: 4498.9,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 69,
    cy: 4467.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 191.8,
    cy: 4493.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 213.5,
    cy: 4343.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 158.7,
    cy: 4359.5,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 93.7,
    cy: 4390.8,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 264.7,
    cy: 4388.9,
    r: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M530.3,4348.3l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M391.5,4477.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M551.8,4421.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M695.4,4350.6l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M529.9,4478.7l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M441.7,4335.7l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M469.7,4399.5l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M731.9,4401.7l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 727.6,
    cy: 4431.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 439.4,
    cy: 4429.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 672.2,
    cy: 4465.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 375.3,
    cy: 4440.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 421,
    cy: 4423.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 581.3,
    cy: 4367.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 468.8,
    cy: 4465.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 728.6,
    cy: 4489.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 639.9,
    cy: 4351.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 626.6,
    cy: 4334.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 396.6,
    cy: 4368.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 544.6,
    cy: 4381.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 428.6,
    cy: 4405.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 421.6,
    cy: 4492.3,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 724.7,
    cy: 4481.6,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 573.9,
    cy: 4475.3,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 437.3,
    cy: 4394,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 593.4,
    cy: 4337.6,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 705.2,
    cy: 4349.9,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 626,
    cy: 4448.3,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 489.4,
    cy: 4367,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 684.7,
    cy: 4395.9,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 691.3,
    cy: 4472.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 409,
    cy: 4447.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 554.8,
    cy: 4390.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 374,
    cy: 4336.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 515.1,
    cy: 3364.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 584.1,
    cy: 3795.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 739.6,
    cy: 3248.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 452.6,
    cy: 3509.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 520.5,
    cy: 3197.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 460.3,
    cy: 3379.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 529.3,
    cy: 3810.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 675.5,
    cy: 3288.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 395.3,
    cy: 3411.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 464.3,
    cy: 3842.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 700.3,
    cy: 3644.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 365.6,
    cy: 3288.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 434.6,
    cy: 3719.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 387.6,
    cy: 3654.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 566,
    cy: 3198.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 660.8,
    cy: 3395.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 600.8,
    cy: 3218.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 695.6,
    cy: 3415.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 566.3,
    cy: 3409.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 635.3,
    cy: 3840.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 671.2,
    cy: 3348.9,
    r: 0.8
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M587.5,7211.8c11.6,0,21.5,5.3,25.6,12.9,1.2-.2,2.3-.3,3.6-.3,10.9,0,19.7,7.8,19.7,17.3s-7.4,16-16.9,17.1v.2h-58.4c-8.5-.2-15.3-6.3-15.3-13.8s6.2-13,14.2-13.7c.5-11,12.6-19.8,27.5-19.8h0Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M246.4,6762c12.4,0,23.2,6.1,28.8,15.2,4.4-2.6,9.6-4.1,15.4-4.1,14.8,0,26.8,10.2,26.8,22.8v.5c2.2-.6,4.6-1,7.1-1,12.6,0,22.8,9.1,22.8,20.3s-9.4,19.6-21.2,20.3h0s-133.8,0-133.8,0v-.7c-1.8.4-3.6.7-5.5.7-11.3,0-20.5-8.1-20.5-18.1s7.6-16.6,17.4-17.9c0-.8-.1-1.7-.1-2.6,0-13.5,11.3-24.4,25.2-24.4s7.1.8,10.2,2.1c5.9-7.9,16-13.1,27.4-13.1h0Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M705.4,1434.7l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M636.4,1003.5l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M495.7,1537.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M400.9,1340.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M682.7,1314.2l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M377.8,1081l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M526.2,1037.1l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M722.7,1037.9l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M482.4,1085.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M502.3,1302.7l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M563.6,881.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M480.8,1229.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M425.4,944.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M602,1497.3l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M453.8,1164.6l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M398.5,879.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M571,1098.3l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M590.9,1315.3l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M652.2,894.3l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M505,1352.5l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M724.9,1251.6l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M420,1018.4l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M562.9,1251.6l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M507.5,966.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4h0Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M679.5,1088.8l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M599.7,1156.1l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M592.6,1419.8l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M524,922.3l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M377.4,1511l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M480.7,1483.2l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M385.9,1286.2l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 718.3,
    cy: 1340,
    r: 0.8
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 413.3,
    cy: 1106.8,
    r: 0.8
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 366.3,
    cy: 798.5,
    r: 0.8
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 669,
    cy: 1363.5,
    r: 0.8
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 600,
    cy: 932.3,
    r: 0.8
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 364,
    cy: 1130.3,
    r: 0.8
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 699.5,
    cy: 1175.6,
    r: 0.8
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 663.5,
    cy: 1221,
    r: 0.8
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 358.5,
    cy: 987.8,
    r: 0.8
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 701.8,
    cy: 954.1,
    r: 0.8
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 573.3,
    cy: 1004.5,
    r: 0.8
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 593.2,
    cy: 1221.6,
    r: 0.8
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 537.8,
    cy: 936.3,
    r: 0.8
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 687,
    cy: 1466,
    r: 0.8
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 618,
    cy: 1034.9,
    r: 0.8
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 637.9,
    cy: 1251.9,
    r: 0.8
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 546.1,
    cy: 1480.9,
    r: 0.8
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 397.9,
    cy: 1148.2,
    r: 0.8
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 477.1,
    cy: 1049.7,
    r: 0.8
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 497,
    cy: 1266.8,
    r: 0.8
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 412.3,
    cy: 975.5,
    r: 0.8
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 451.3,
    cy: 1283.9,
    r: 0.8
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M512.5,862c.4,0,.8.3.8.8s-.3.8-.8.8-.8-.3-.8-.8.3-.8.8-.8Z"
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 498.3,
    cy: 1438.6,
    r: 0.8
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 403.5,
    cy: 1241.6,
    r: 0.8
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 509.3,
    cy: 1163.9,
    r: 0.8
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 453.9,
    cy: 878.6,
    r: 0.8
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 553.1,
    cy: 1185,
    r: 0.8
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 467.3,
    cy: 895.5,
    r: 0.8
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 465.5,
    cy: 1289.1,
    r: 0.8
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 697.3,
    cy: 861.5,
    r: 0.8
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 493.6,
    cy: 966.7,
    r: 0.8
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 673.7,
    cy: 1564.7,
    r: 0.8
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604.7,
    cy: 1133.5,
    r: 0.8
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 549.3,
    cy: 848.2,
    r: 0.8
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 497.3,
    cy: 1388.5,
    r: 0.8
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604,
    cy: 1245.3,
    r: 0.8
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 666.2,
    cy: 1557.2,
    r: 2
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 585.1,
    cy: 1364.3,
    r: 2
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 386.8,
    cy: 1441.8,
    r: 2
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 598.9,
    cy: 1547.8,
    r: 2
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 450.7,
    cy: 1215.1,
    r: 2
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 395.3,
    cy: 929.8,
    r: 2
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 448.1,
    cy: 988.3,
    r: 2
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 529.9,
    cy: 1116.7,
    r: 2
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 369.1,
    cy: 748.3,
    r: 2
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 549.8,
    cy: 1333.7,
    r: 2
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 363.2,
    cy: 1392.3,
    r: 2
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 644.3,
    cy: 1471.1,
    r: 2
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 380.1,
    cy: 1185.3,
    r: 2
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 575.3,
    cy: 1039.9,
    r: 2
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 519.9,
    cy: 754.7,
    r: 2
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 595.2,
    cy: 1257,
    r: 2
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 429.1,
    cy: 1562.3,
    r: 2
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 555.8,
    cy: 1177.6,
    r: 2
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 500.5,
    cy: 892.3,
    r: 2
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 696,
    cy: 1544.7,
    r: 1.2
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 627,
    cy: 1113.5,
    r: 1.2
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 646.9,
    cy: 1330.6,
    r: 1.2
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 592.2,
    cy: 1498.1,
    r: 0.8
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 444,
    cy: 1165.4,
    r: 0.8
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 388.7,
    cy: 880.1,
    r: 0.8
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 523.2,
    cy: 1066.9,
    r: 0.8
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 543.2,
    cy: 1284,
    r: 0.8
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 604.5,
    cy: 863,
    r: 0.8
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 533.5,
    cy: 1550.6,
    r: 0.8
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 385.3,
    cy: 1217.8,
    r: 0.8
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 464.5,
    cy: 1119.4,
    r: 0.8
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 409.2,
    cy: 834.1,
    r: 0.8
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 484.5,
    cy: 1336.5,
    r: 0.8
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 438.8,
    cy: 1353.6,
    r: 0.8
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 526.9,
    cy: 1474.2,
    r: 1.2
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 378.7,
    cy: 1141.5,
    r: 1.2
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 457.9,
    cy: 1043.1,
    r: 1.2
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 477.8,
    cy: 1260.2,
    r: 1.2
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 539.1,
    cy: 839.1,
    r: 1.2
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 432.1,
    cy: 1277.2,
    r: 1.2
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 719.9,
    cy: 893.1,
    r: 1.2
  })), _circle493 || (_circle493 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 586.4,
    cy: 1420.2,
    r: 1.2
  })), _circle494 || (_circle494 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 517.4,
    cy: 989.1,
    r: 1.2
  })), _circle495 || (_circle495 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 361.9,
    cy: 1536.1,
    r: 1.2
  })), _circle496 || (_circle496 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 713.2,
    cy: 1585.4,
    r: 1.2
  })), _circle497 || (_circle497 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 580.9,
    cy: 1587,
    r: 1.2
  })), _circle498 || (_circle498 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 641.2,
    cy: 1404.6,
    r: 1.2
  })), _circle499 || (_circle499 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 572.2,
    cy: 973.4,
    r: 1.2
  })), _circle500 || (_circle500 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 426,
    cy: 1495.8,
    r: 1.2
  })), _circle501 || (_circle501 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 706.1,
    cy: 1373.3,
    r: 1.2
  })), _circle502 || (_circle502 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 637.1,
    cy: 942.1,
    r: 1.2
  })), _circle503 || (_circle503 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 401.2,
    cy: 1140.1,
    r: 1.2
  })), _circle504 || (_circle504 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 735.9,
    cy: 1496.2,
    r: 1.2
  })), _circle505 || (_circle505 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 666.9,
    cy: 1065,
    r: 1.2
  })), _circle506 || (_circle506 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 713.9,
    cy: 1130.1,
    r: 1.2
  })), _circle507 || (_circle507 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 440.7,
    cy: 1389.2,
    r: 1.2
  })), _circle508 || (_circle508 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 500.7,
    cy: 1566.2,
    r: 0.8
  })), _circle509 || (_circle509 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 352.5,
    cy: 1233.5,
    r: 0.8
  })), _circle510 || (_circle510 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 405.9,
    cy: 1369.2,
    r: 0.8
  })), _circle511 || (_circle511 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 535.1,
    cy: 1375.2,
    r: 0.8
  })), _circle512 || (_circle512 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 466.1,
    cy: 944.1,
    r: 0.8
  })), _circle513 || (_circle513 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 430.3,
    cy: 1435.5,
    r: 0.8
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M345.4,1526.7l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M276.4,1095.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M40.9,1432.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M322.7,1406.2l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M17.8,1173l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M166.2,1129.1l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M362.7,1129.9l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M122.4,1177.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M280.8,1313.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M101.8,927.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M142.3,1394.7l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M363.8,917.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M203.6,973.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M120.8,1321.6l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M65.4,1036.3l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M342.4,844.2l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M182.1,900.5l-.8-6.8-3.4-.8,3.4-.8.8-6.8.8,6.8,3.4.8-3.4.8-.8,6.8Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M242,1589.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M93.8,1256.6l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M38.5,971.3l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M211,1190.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M204,843.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M230.9,1407.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M292.2,986.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M145,1444.5l-.6-4.4-4.4-.7,4.4-.7.6-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M364.9,1343.6l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M60,1110.4l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7s-.7,4.4-.7,4.4Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M202.9,1343.6l-.7-4.4-4.4-.7,4.4-.7.7-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M147.5,1058.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M264.2,922.5l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M319.5,1180.8l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M239.7,1248.1l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M2,920.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.7,4.4,4.4.7-4.4.7s-.7,4.4-.7,4.4Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M232.6,1511.8l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M164,1014.3l-.6-4.4-4.4-.7,4.4-.7.6-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M120.7,1575.2l-.7-4.4-4.4-.7,4.4-.7.7-4.4.7,4.4,4.4.7-4.4.7-.7,4.4Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M25.9,1378.2l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M247.5,900.8l-.6-4.4-4.4-.7,4.4-.7.6-4.4.6,4.4,4.4.7-4.4.7-.6,4.4Z"
  })), _circle514 || (_circle514 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 358.3,
    cy: 1432,
    r: 0.8
  })), _circle515 || (_circle515 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 53.3,
    cy: 1198.8,
    r: 0.8
  })), _circle516 || (_circle516 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 6.3,
    cy: 890.5,
    r: 0.8
  })), _circle517 || (_circle517 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 309,
    cy: 1455.5,
    r: 0.8
  })), _circle518 || (_circle518 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 240,
    cy: 1024.3,
    r: 0.8
  })), _circle519 || (_circle519 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 4,
    cy: 1222.3,
    r: 0.8,
    transform: "translate(-1218.3 1225.1) rotate(-89.9)"
  })), _circle520 || (_circle520 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 339.5,
    cy: 1267.6,
    r: 0.8
  })), _circle521 || (_circle521 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 303.5,
    cy: 1313,
    r: 0.8
  })), _circle522 || (_circle522 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 341.8,
    cy: 1046.1,
    r: 0.8
  })), _circle523 || (_circle523 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 213.3,
    cy: 1096.5,
    r: 0.8
  })), _circle524 || (_circle524 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 233.2,
    cy: 1313.6,
    r: 0.8
  })), _circle525 || (_circle525 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 177.8,
    cy: 1028.3,
    r: 0.8
  })), _circle526 || (_circle526 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 294.5,
    cy: 892.5,
    r: 0.8
  })), _circle527 || (_circle527 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 327,
    cy: 1558,
    r: 0.8
  })), _circle528 || (_circle528 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 258,
    cy: 1126.9,
    r: 0.8
  })), _circle529 || (_circle529 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 277.9,
    cy: 1343.9,
    r: 0.8
  })), _circle530 || (_circle530 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 186.1,
    cy: 1572.9,
    r: 0.8
  })), _circle531 || (_circle531 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 37.9,
    cy: 1240.2,
    r: 0.8
  })), _circle532 || (_circle532 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 117.1,
    cy: 1141.7,
    r: 0.8
  })), _circle533 || (_circle533 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 61.7,
    cy: 856.4,
    r: 0.8
  })), _circle534 || (_circle534 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 137,
    cy: 1358.8,
    r: 0.8
  })), _circle535 || (_circle535 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 358.5,
    cy: 881.4,
    r: 0.8
  })), _circle536 || (_circle536 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 52.3,
    cy: 1067.5,
    r: 0.8
  })), _circle537 || (_circle537 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 91.3,
    cy: 1375.9,
    r: 0.8
  })), _circle538 || (_circle538 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 312.8,
    cy: 898.5,
    r: 0.8
  })), _circle539 || (_circle539 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 152.6,
    cy: 954.8,
    r: 0.8
  })), _circle540 || (_circle540 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 138.3,
    cy: 1530.6,
    r: 0.8
  })), _circle541 || (_circle541 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 43.5,
    cy: 1333.6,
    r: 0.8
  })), _circle542 || (_circle542 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 265.1,
    cy: 856.2,
    r: 0.8
  })), _circle543 || (_circle543 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 5.3,
    cy: 832.5,
    r: 0.8
  })), _circle544 || (_circle544 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 149.3,
    cy: 1255.9,
    r: 0.8
  })), _circle545 || (_circle545 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 93.9,
    cy: 970.6,
    r: 0.8
  })), _circle546 || (_circle546 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 193.1,
    cy: 1277,
    r: 0.8
  })), _circle547 || (_circle547 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 107.3,
    cy: 987.5,
    r: 0.8
  })), _circle548 || (_circle548 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 105.4,
    cy: 1381.1,
    r: 0.8
  })), _circle549 || (_circle549 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 337.3,
    cy: 953.5,
    r: 0.8
  })), _circle550 || (_circle550 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 133.6,
    cy: 1058.7,
    r: 0.8
  })), _circle551 || (_circle551 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 244.6,
    cy: 1225.5,
    r: 0.8
  })), _circle552 || (_circle552 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 189.3,
    cy: 940.2,
    r: 0.8
  })), _circle553 || (_circle553 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 137.3,
    cy: 1480.5,
    r: 0.8
  })), _circle554 || (_circle554 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 244,
    cy: 1337.3,
    r: 0.8
  })), _circle555 || (_circle555 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 305.3,
    cy: 916.2,
    r: 0.8
  })), _circle556 || (_circle556 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 41.1,
    cy: 1012.3,
    r: 2
  })), _circle557 || (_circle557 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 225.1,
    cy: 1456.3,
    r: 2
  })), _circle558 || (_circle558 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 26.8,
    cy: 1533.8,
    r: 2
  })), _circle559 || (_circle559 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 90.7,
    cy: 1307.1,
    r: 2
  })), _circle560 || (_circle560 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 6.1,
    cy: 1040.3,
    r: 2,
    transform: "translate(-1.6 0) rotate(0)"
  })), _circle561 || (_circle561 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 88.1,
    cy: 1080.3,
    r: 2
  })), _circle562 || (_circle562 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 169.9,
    cy: 1208.7,
    r: 2
  })), _circle563 || (_circle563 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 9.1,
    cy: 840.3,
    r: 2
  })), _circle564 || (_circle564 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 189.8,
    cy: 1425.7,
    r: 2
  })), _circle565 || (_circle565 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 3.2,
    cy: 1484.3,
    r: 2
  })), _circle566 || (_circle566 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 20.1,
    cy: 1277.3,
    r: 2
  })), _circle567 || (_circle567 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 215.3,
    cy: 1131.9,
    r: 2
  })), _circle568 || (_circle568 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 159.9,
    cy: 846.7,
    r: 2
  })), _circle569 || (_circle569 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 235.2,
    cy: 1349,
    r: 2
  })), _circle570 || (_circle570 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 296.5,
    cy: 928,
    r: 2
  })), _circle571 || (_circle571 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 195.9,
    cy: 1269.6,
    r: 2
  })), _circle572 || (_circle572 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 276.1,
    cy: 1269.3,
    r: 2
  })), _circle573 || (_circle573 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 140.5,
    cy: 984.3,
    r: 2
  })), _circle574 || (_circle574 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 267,
    cy: 1205.5,
    r: 1.2
  })), _circle575 || (_circle575 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 286.9,
    cy: 1422.6,
    r: 1.2
  })), _circle576 || (_circle576 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 232.2,
    cy: 1590.1,
    r: 0.8
  })), _circle577 || (_circle577 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 84,
    cy: 1257.4,
    r: 0.8
  })), _circle578 || (_circle578 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 28.7,
    cy: 972.1,
    r: 0.8
  })), _circle579 || (_circle579 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 163.2,
    cy: 1158.9,
    r: 0.8
  })), _circle580 || (_circle580 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 107.9,
    cy: 873.7,
    r: 0.8
  })), _circle581 || (_circle581 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 183.2,
    cy: 1376,
    r: 0.8
  })), _circle582 || (_circle582 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 244.4,
    cy: 955,
    r: 0.8
  })), _circle583 || (_circle583 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 25.3,
    cy: 1309.8,
    r: 0.8
  })), _circle584 || (_circle584 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 246.9,
    cy: 832.4,
    r: 0.8
  })), _circle585 || (_circle585 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 104.5,
    cy: 1211.4,
    r: 0.8
  })), _circle586 || (_circle586 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 49.2,
    cy: 926.1,
    r: 0.8
  })), _circle587 || (_circle587 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 124.5,
    cy: 1428.5,
    r: 0.8
  })), _circle588 || (_circle588 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 78.8,
    cy: 1445.6,
    r: 0.8
  })), _circle589 || (_circle589 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 166.9,
    cy: 1566.2,
    r: 1.2
  })), _circle590 || (_circle590 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 18.7,
    cy: 1233.5,
    r: 1.2
  })), _circle591 || (_circle591 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 97.9,
    cy: 1135.1,
    r: 1.2
  })), _circle592 || (_circle592 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 42.5,
    cy: 849.8,
    r: 1.2
  })), _circle593 || (_circle593 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 117.8,
    cy: 1352.2,
    r: 1.2
  })), _circle594 || (_circle594 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 324.9,
    cy: 874.1,
    r: 1.2
  })), _circle595 || (_circle595 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 179.1,
    cy: 931.1,
    r: 1.2
  })), _circle596 || (_circle596 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 72.1,
    cy: 1369.2,
    r: 1.2
  })), _circle597 || (_circle597 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 359.9,
    cy: 985.1,
    r: 1.2
  })), _circle598 || (_circle598 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 226.4,
    cy: 1512.2,
    r: 1.2
  })), _circle599 || (_circle599 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 157.4,
    cy: 1081.1,
    r: 1.2
  })), _circle600 || (_circle600 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 317.9,
    cy: 1285.1,
    r: 1.2
  })), _circle601 || (_circle601 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 281.2,
    cy: 1496.6,
    r: 1.2
  })), _circle602 || (_circle602 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 212.2,
    cy: 1065.4,
    r: 1.2
  })), _circle603 || (_circle603 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 66,
    cy: 1587.8,
    r: 1.2
  })), _circle604 || (_circle604 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 346.1,
    cy: 1465.3,
    r: 1.2
  })), _circle605 || (_circle605 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 277.1,
    cy: 1034.1,
    r: 1.2
  })), _circle606 || (_circle606 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 41.2,
    cy: 1232.1,
    r: 1.2
  })), _circle607 || (_circle607 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 306.9,
    cy: 1157,
    r: 1.2
  })), _circle608 || (_circle608 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 353.9,
    cy: 1222.1,
    r: 1.2
  })), _circle609 || (_circle609 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 80.7,
    cy: 1481.2,
    r: 1.2
  })), _circle610 || (_circle610 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 45.9,
    cy: 1461.2,
    r: 0.8
  })), _circle611 || (_circle611 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 175.1,
    cy: 1467.2,
    r: 0.8
  })), _circle612 || (_circle612 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 106.1,
    cy: 1036.1,
    r: 0.8
  })), _circle613 || (_circle613 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 70.3,
    cy: 1527.5,
    r: 0.8
  })), _circle614 || (_circle614 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 313.6,
    cy: 783.7,
    r: 0.8
  })), _circle615 || (_circle615 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 365.7,
    cy: 803.6,
    r: 2
  })), _circle616 || (_circle616 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 238.9,
    cy: 766.8,
    r: 2
  })), _circle617 || (_circle617 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 69.1,
    cy: 781.3,
    r: 2
  })), _circle618 || (_circle618 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 336,
    cy: 763.7,
    r: 1.2
  })), _circle619 || (_circle619 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1.9,
    cy: 755.1,
    r: 1.2
  })), _circle620 || (_circle620 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 220.9,
    cy: 806,
    r: 1.2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M24.6,167.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M93.6,598.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M234.4,65.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M329.2,262.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M47.3,288.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M352.3,521.3l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M203.9,565.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M7.4,564.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8s.8-6.8.8-6.8Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M247.7,516.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M227.8,299.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M166.5,720.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M249.3,372.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M304.6,658l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M128,105l.6,4.4,4.4.7-4.4.7-.6,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M276.2,437.7l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M331.6,723l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M159.1,504.1l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4h0Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M139.2,287l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M77.9,708.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M225.1,249.8l.6,4.4,4.4.7-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.7.6-4.4Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M5.2,350.8l.7,4.4,4.4.6-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6s.7-4.4.7-4.4Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M310.1,584l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M167.2,350.8l.6,4.4,4.4.6-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.6.6-4.4Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M222.6,636.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M50.5,513.6l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M130.4,446.3l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M137.4,182.5l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M206.1,680.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M352.6,91.3l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M249.4,119.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7s.6-4.4.6-4.4Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M344.1,316.1l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _circle621 || (_circle621 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 11.8,
    cy: 262.3,
    r: 0.8
  })), _circle622 || (_circle622 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 316.8,
    cy: 495.5,
    r: 0.8
  })), _circle623 || (_circle623 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 363.8,
    cy: 803.9,
    r: 0.8
  })), _circle624 || (_circle624 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 61.1,
    cy: 238.9,
    r: 0.8
  })), _circle625 || (_circle625 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 130.1,
    cy: 670,
    r: 0.8
  })), _circle626 || (_circle626 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 366.1,
    cy: 472,
    r: 0.8
  })), _circle627 || (_circle627 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 30.6,
    cy: 426.7,
    r: 0.8
  })), _circle628 || (_circle628 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 66.6,
    cy: 381.3,
    r: 0.8
  })), _circle629 || (_circle629 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 371.5,
    cy: 614.5,
    r: 0.8
  })), _circle630 || (_circle630 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 28.2,
    cy: 648.2,
    r: 0.8
  })), _circle631 || (_circle631 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 156.8,
    cy: 597.9,
    r: 0.8
  })), _circle632 || (_circle632 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 136.9,
    cy: 380.8,
    r: 0.8
  })), _circle633 || (_circle633 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 192.3,
    cy: 666.1,
    r: 0.8
  })), _circle634 || (_circle634 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 43.1,
    cy: 136.3,
    r: 0.8
  })), _circle635 || (_circle635 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 112.1,
    cy: 567.5,
    r: 0.8
  })), _circle636 || (_circle636 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 92.2,
    cy: 350.4,
    r: 0.8
  })), _circle637 || (_circle637 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 184,
    cy: 121.4,
    r: 0.8
  })), _circle638 || (_circle638 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 332.2,
    cy: 454.2,
    r: 0.8
  })), _circle639 || (_circle639 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 253,
    cy: 552.6,
    r: 0.8
  })), _circle640 || (_circle640 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 233.1,
    cy: 335.5,
    r: 0.8
  })), _circle641 || (_circle641 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 317.8,
    cy: 626.9,
    r: 0.8
  })), _circle642 || (_circle642 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 278.8,
    cy: 318.4,
    r: 0.8
  })), _circle643 || (_circle643 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 217.5,
    cy: 739.5,
    r: 0.8
  })), _circle644 || (_circle644 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 231.8,
    cy: 163.7,
    r: 0.8
  })), _circle645 || (_circle645 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 326.5,
    cy: 360.7,
    r: 0.8
  })), _circle646 || (_circle646 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 220.8,
    cy: 438.5,
    r: 0.8
  })), _circle647 || (_circle647 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 276.2,
    cy: 723.7,
    r: 0.8
  })), _circle648 || (_circle648 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 176.9,
    cy: 417.3,
    r: 0.8
  })), _circle649 || (_circle649 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 262.8,
    cy: 706.9,
    r: 0.8
  })), _circle650 || (_circle650 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 264.6,
    cy: 313.2,
    r: 0.8
  })), _circle651 || (_circle651 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 32.8,
    cy: 740.9,
    r: 0.8
  })), _circle652 || (_circle652 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 236.4,
    cy: 635.7,
    r: 0.8
  })), _circle653 || (_circle653 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 56.4,
    cy: 37.7,
    r: 0.8
  })), _circle654 || (_circle654 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 125.4,
    cy: 468.9,
    r: 0.8
  })), _circle655 || (_circle655 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 180.8,
    cy: 754.2,
    r: 0.8
  })), _circle656 || (_circle656 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 232.8,
    cy: 213.9,
    r: 0.8
  })), _circle657 || (_circle657 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 126.1,
    cy: 357,
    r: 0.8
  })), _circle658 || (_circle658 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 63.8,
    cy: 45.1,
    r: 2
  })), _circle659 || (_circle659 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 145,
    cy: 238,
    r: 2
  })), _circle660 || (_circle660 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 343.2,
    cy: 160.6,
    r: 2
  })), _circle661 || (_circle661 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 4.4,
    cy: 17.7,
    r: 2
  })), _circle662 || (_circle662 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 131.2,
    cy: 54.5,
    r: 2
  })), _circle663 || (_circle663 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 279.4,
    cy: 387.2,
    r: 2
  })), _circle664 || (_circle664 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 334.8,
    cy: 672.5,
    r: 2
  })), _circle665 || (_circle665 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 282,
    cy: 614,
    r: 2
  })), _circle666 || (_circle666 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 200.2,
    cy: 485.7,
    r: 2
  })), _circle667 || (_circle667 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 361,
    cy: 854,
    r: 2
  })), _circle668 || (_circle668 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 180.2,
    cy: 268.6,
    r: 2
  })), _circle669 || (_circle669 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 272.1,
    cy: 13,
    r: 2
  })), _circle670 || (_circle670 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 366.9,
    cy: 210,
    r: 2
  })), _circle671 || (_circle671 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 85.8,
    cy: 131.2,
    r: 2
  })), _circle672 || (_circle672 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 350,
    cy: 417,
    r: 2
  })), _circle673 || (_circle673 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 154.8,
    cy: 562.4,
    r: 2
  })), _circle674 || (_circle674 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 134.9,
    cy: 345.3,
    r: 2
  })), _circle675 || (_circle675 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 301,
    cy: 40,
    r: 2
  })), _circle676 || (_circle676 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 174.2,
    cy: 424.8,
    r: 2
  })), _circle677 || (_circle677 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 229.6,
    cy: 710,
    r: 2
  })), _circle678 || (_circle678 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 34.1,
    cy: 57.7,
    r: 1.2
  })), _circle679 || (_circle679 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 103.1,
    cy: 488.8,
    r: 1.2
  })), _circle680 || (_circle680 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 83.2,
    cy: 271.7,
    r: 1.2
  })), _circle681 || (_circle681 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 137.8,
    cy: 104.2,
    r: 0.8
  })), _circle682 || (_circle682 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 286,
    cy: 437,
    r: 0.8
  })), _circle683 || (_circle683 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 341.4,
    cy: 722.2,
    r: 0.8
  })), _circle684 || (_circle684 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 206.8,
    cy: 535.4,
    r: 0.8
  })), _circle685 || (_circle685 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 186.9,
    cy: 318.3,
    r: 0.8
  })), _circle686 || (_circle686 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 125.6,
    cy: 739.4,
    r: 0.8
  })), _circle687 || (_circle687 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 196.5,
    cy: 51.8,
    r: 0.8
  })), _circle688 || (_circle688 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 344.7,
    cy: 384.5,
    r: 0.8
  })), _circle689 || (_circle689 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 265.5,
    cy: 483,
    r: 0.8
  })), _circle690 || (_circle690 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 320.9,
    cy: 768.2,
    r: 0.8
  })), _circle691 || (_circle691 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 245.6,
    cy: 265.9,
    r: 0.8
  })), _circle692 || (_circle692 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 291.3,
    cy: 248.8,
    r: 0.8
  })), _circle693 || (_circle693 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 203.2,
    cy: 128.1,
    r: 1.2
  })), _circle694 || (_circle694 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 351.4,
    cy: 460.8,
    r: 1.2
  })), _circle695 || (_circle695 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 272.2,
    cy: 559.3,
    r: 1.2
  })), _circle696 || (_circle696 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 252.3,
    cy: 342.2,
    r: 1.2
  })), _circle697 || (_circle697 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 191,
    cy: 763.3,
    r: 1.2
  })), _circle698 || (_circle698 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 298,
    cy: 325.1,
    r: 1.2
  })), _circle699 || (_circle699 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 10.2,
    cy: 709.2,
    r: 1.2
  })), _circle700 || (_circle700 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 143.7,
    cy: 182.1,
    r: 1.2
  })), _circle701 || (_circle701 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 212.7,
    cy: 613.3,
    r: 1.2
  })), _circle702 || (_circle702 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 368.2,
    cy: 66.2,
    r: 1.2
  })), _circle703 || (_circle703 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 16.9,
    cy: 17,
    r: 1.2
  })), _circle704 || (_circle704 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 149.2,
    cy: 15.4,
    r: 1.2
  })), _circle705 || (_circle705 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 88.9,
    cy: 197.8,
    r: 1.2
  })), _circle706 || (_circle706 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 157.9,
    cy: 628.9,
    r: 1.2
  })), _circle707 || (_circle707 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 304.1,
    cy: 106.6,
    r: 1.2
  })), _circle708 || (_circle708 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 23.9,
    cy: 229.1,
    r: 1.2
  })), _circle709 || (_circle709 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 92.9,
    cy: 660.2,
    r: 1.2
  })), _circle710 || (_circle710 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 328.9,
    cy: 462.2,
    r: 1.2
  })), _circle711 || (_circle711 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 63.2,
    cy: 537.3,
    r: 1.2,
    transform: "translate(-475.6 586.4) rotate(-88.5)"
  })), _circle712 || (_circle712 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 16.2,
    cy: 472.2,
    r: 1.2
  })), _circle713 || (_circle713 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 194.6,
    cy: 16.2,
    r: 1.2
  })), _circle714 || (_circle714 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 289.4,
    cy: 213.2,
    r: 1.2
  })), _circle715 || (_circle715 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 229.4,
    cy: 36.1,
    r: 0.8
  })), _circle716 || (_circle716 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 377.6,
    cy: 368.9,
    r: 0.8
  })), _circle717 || (_circle717 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 324.2,
    cy: 233.1,
    r: 0.8
  })), _circle718 || (_circle718 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 195,
    cy: 227.1,
    r: 0.8
  })), _circle719 || (_circle719 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 264,
    cy: 658.3,
    r: 0.8
  })), _circle720 || (_circle720 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 299.8,
    cy: 166.9,
    r: 0.8
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M384.6,75.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M453.6,506.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8h0Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M689.2,170.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M407.3,196.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M712.3,429.4l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M563.9,473.2l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M367.4,472.5l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M607.7,424.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M449.2,289.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M628.2,675.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M587.8,207.6l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M366.2,685.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M526.5,628.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M609.3,280.7l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M664.7,566l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M387.7,758.1l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M548,701.8l.8,6.8,3.4.8-3.4.8-.8,6.8-.8-6.8-3.4-.8,3.4-.8.8-6.8Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M488,13l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M636.2,345.7l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M691.6,631l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M519.1,412.1l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M526.1,759.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M499.2,195l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M437.9,616.1l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M585.1,157.8l.7,4.4,4.4.7-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.7.7-4.4Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M365.1,258.8l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M670.1,492l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M527.2,258.8l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M582.5,544.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M465.9,679.9l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M410.5,421.6l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M490.4,354.3l.6,4.4,4.4.6-4.4.6-.6,4.4-.6-4.4-4.4-.6,4.4-.6.6-4.4Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M728.1,682.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M497.4,90.5l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M566.1,588.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M609.4,27.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.6s.7-4.4.7-4.4Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M704.2,224.1l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M482.6,701.5l.6,4.4,4.4.7-4.4.7-.6,4.4-.6-4.4-4.4-.7,4.4-.7.6-4.4Z"
  })), _circle721 || (_circle721 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 371.8,
    cy: 170.3,
    r: 0.8
  })), _circle722 || (_circle722 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 676.8,
    cy: 403.5,
    r: 0.8
  })), _circle723 || (_circle723 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 723.8,
    cy: 711.9,
    r: 0.8
  })), _circle724 || (_circle724 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 421.1,
    cy: 146.9,
    r: 0.8
  })), _circle725 || (_circle725 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 490.1,
    cy: 578,
    r: 0.8
  })), _circle726 || (_circle726 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 726.1,
    cy: 380,
    r: 0.8
  })), _circle727 || (_circle727 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 390.6,
    cy: 334.7,
    r: 0.8
  })), _circle728 || (_circle728 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 426.6,
    cy: 289.3,
    r: 0.8
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M731.5,521.7c.4,0,.8.3.8.8s-.3.8-.8.8-.8-.3-.8-.8.3-.8.8-.8Z"
  })), _circle729 || (_circle729 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 388.2,
    cy: 556.2,
    r: 0.8
  })), _circle730 || (_circle730 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 516.8,
    cy: 505.9,
    r: 0.8
  })), _circle731 || (_circle731 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 496.9,
    cy: 288.8,
    r: 0.8
  })), _circle732 || (_circle732 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 552.3,
    cy: 574.1,
    r: 0.8
  })), _circle733 || (_circle733 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 435.6,
    cy: 709.9,
    r: 0.8
  })), _circle734 || (_circle734 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 403.1,
    cy: 44.3,
    r: 0.8
  })), _circle735 || (_circle735 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 472.1,
    cy: 475.5,
    r: 0.8
  })), _circle736 || (_circle736 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 452.2,
    cy: 258.4,
    r: 0.8
  })), _circle737 || (_circle737 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 544,
    cy: 29.4,
    r: 0.8
  })), _circle738 || (_circle738 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 692.2,
    cy: 362.2,
    r: 0.8
  })), _circle739 || (_circle739 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 613,
    cy: 460.6,
    r: 0.8
  })), _circle740 || (_circle740 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 668.4,
    cy: 745.9,
    r: 0.8
  })), _circle741 || (_circle741 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 593.1,
    cy: 243.5,
    r: 0.8
  })), _circle742 || (_circle742 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 371.5,
    cy: 721,
    r: 0.8
  })), _circle743 || (_circle743 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 677.8,
    cy: 534.9,
    r: 0.8
  })), _circle744 || (_circle744 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 638.8,
    cy: 226.4,
    r: 0.8
  })), _circle745 || (_circle745 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 417.2,
    cy: 703.9,
    r: 0.8
  })), _circle746 || (_circle746 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 577.5,
    cy: 647.5,
    r: 0.8
  })), _circle747 || (_circle747 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 591.8,
    cy: 71.7,
    r: 0.8
  })), _circle748 || (_circle748 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 686.5,
    cy: 268.7,
    r: 0.8
  })), _circle749 || (_circle749 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 465,
    cy: 746.2,
    r: 0.8
  })), _circle750 || (_circle750 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 724.8,
    cy: 769.9,
    r: 0.8
  })), _circle751 || (_circle751 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 580.8,
    cy: 346.5,
    r: 0.8
  })), _circle752 || (_circle752 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 636.2,
    cy: 631.7,
    r: 0.8
  })), _circle753 || (_circle753 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 537,
    cy: 325.3,
    r: 0.8
  })), _circle754 || (_circle754 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 622.8,
    cy: 614.9,
    r: 0.8
  })), _circle755 || (_circle755 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 624.6,
    cy: 221.2,
    r: 0.8
  })), _circle756 || (_circle756 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 392.8,
    cy: 648.9,
    r: 0.8
  })), _circle757 || (_circle757 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 596.4,
    cy: 543.7,
    r: 0.8
  })), _circle758 || (_circle758 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 485.4,
    cy: 376.9,
    r: 0.8
  })), _circle759 || (_circle759 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 540.8,
    cy: 662.2,
    r: 0.8
  })), _circle760 || (_circle760 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 592.8,
    cy: 121.9,
    r: 0.8
  })), _circle761 || (_circle761 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 486.1,
    cy: 265,
    r: 0.8
  })), _circle762 || (_circle762 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 424.8,
    cy: 686.1,
    r: 0.8
  })), _circle763 || (_circle763 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 689,
    cy: 590,
    r: 2
  })), _circle764 || (_circle764 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 505,
    cy: 146,
    r: 2
  })), _circle765 || (_circle765 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 703.2,
    cy: 68.6,
    r: 2
  })), _circle766 || (_circle766 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 639.4,
    cy: 295.2,
    r: 2
  })), _circle767 || (_circle767 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 724,
    cy: 562,
    r: 2
  })), _circle768 || (_circle768 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 417.8,
    cy: 772.7,
    r: 2
  })), _circle769 || (_circle769 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 642,
    cy: 522,
    r: 2
  })), _circle770 || (_circle770 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 560.2,
    cy: 393.7,
    r: 2
  })), _circle771 || (_circle771 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 721,
    cy: 762,
    r: 2
  })), _circle772 || (_circle772 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 540.2,
    cy: 176.6,
    r: 2
  })), _circle773 || (_circle773 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 726.8,
    cy: 118,
    r: 2
  })), _circle774 || (_circle774 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 445.8,
    cy: 39.2,
    r: 2
  })), _circle775 || (_circle775 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 710,
    cy: 325,
    r: 2
  })), _circle776 || (_circle776 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 514.8,
    cy: 470.4,
    r: 2
  })), _circle777 || (_circle777 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 570.2,
    cy: 755.7,
    r: 2
  })), _circle778 || (_circle778 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 494.9,
    cy: 253.3,
    r: 2
  })), _circle779 || (_circle779 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 433.6,
    cy: 674.4,
    r: 2
  })), _circle780 || (_circle780 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 534.2,
    cy: 332.8,
    r: 2
  })), _circle781 || (_circle781 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 454,
    cy: 333,
    r: 2
  })), _circle782 || (_circle782 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 589.6,
    cy: 618,
    r: 2
  })), _circle783 || (_circle783 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 463.1,
    cy: 396.8,
    r: 1.2
  })), _circle784 || (_circle784 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 443.2,
    cy: 179.7,
    r: 1.2
  })), _circle785 || (_circle785 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 497.8,
    cy: 12.2,
    r: 0.8
  })), _circle786 || (_circle786 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 646,
    cy: 345,
    r: 0.8
  })), _circle787 || (_circle787 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 701.4,
    cy: 630.2,
    r: 0.8
  })), _circle788 || (_circle788 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 566.8,
    cy: 443.4,
    r: 0.8
  })), _circle789 || (_circle789 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 622.2,
    cy: 728.7,
    r: 0.8
  })), _circle790 || (_circle790 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 546.9,
    cy: 226.3,
    r: 0.8
  })), _circle791 || (_circle791 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 485.6,
    cy: 647.4,
    r: 0.8
  })), _circle792 || (_circle792 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 704.7,
    cy: 292.5,
    r: 0.8
  })), _circle793 || (_circle793 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 483.2,
    cy: 770,
    r: 0.8
  })), _circle794 || (_circle794 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 625.5,
    cy: 391,
    r: 0.8
  })), _circle795 || (_circle795 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 680.9,
    cy: 676.2,
    r: 0.8
  })), _circle796 || (_circle796 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 605.6,
    cy: 173.9,
    r: 0.8
  })), _circle797 || (_circle797 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 651.3,
    cy: 156.8,
    r: 0.8
  })), _circle798 || (_circle798 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 563.2,
    cy: 36.1,
    r: 1.2
  })), _circle799 || (_circle799 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 711.4,
    cy: 368.8,
    r: 1.2
  })), _circle800 || (_circle800 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 632.2,
    cy: 467.3,
    r: 1.2
  })), _circle801 || (_circle801 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 687.6,
    cy: 752.6,
    r: 1.2
  })), _circle802 || (_circle802 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 612.3,
    cy: 250.2,
    r: 1.2
  })), _circle803 || (_circle803 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 405.2,
    cy: 728.2,
    r: 1.2
  })), _circle804 || (_circle804 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 551,
    cy: 671.3,
    r: 1.2
  })), _circle805 || (_circle805 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 658,
    cy: 233.1,
    r: 1.2
  })), _circle806 || (_circle806 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 370.2,
    cy: 617.2,
    r: 1.2
  })), _circle807 || (_circle807 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 503.7,
    cy: 90.1,
    r: 1.2
  })), _circle808 || (_circle808 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 572.7,
    cy: 521.3,
    r: 1.2
  })), _circle809 || (_circle809 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 412.2,
    cy: 317.2,
    r: 1.2
  })), _circle810 || (_circle810 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 448.9,
    cy: 105.8,
    r: 1.2
  })), _circle811 || (_circle811 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 517.9,
    cy: 536.9,
    r: 1.2
  })), _circle812 || (_circle812 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 664.1,
    cy: 14.6,
    r: 1.2
  })), _circle813 || (_circle813 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 383.9,
    cy: 137.1,
    r: 1.2
  })), _circle814 || (_circle814 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 452.9,
    cy: 568.2,
    r: 1.2
  })), _circle815 || (_circle815 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 688.9,
    cy: 370.2,
    r: 1.2
  })), _circle816 || (_circle816 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 354.2,
    cy: 14.2,
    r: 1.2
  })), _circle817 || (_circle817 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 423.2,
    cy: 445.4,
    r: 1.2
  })), _circle818 || (_circle818 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 376.2,
    cy: 380.2,
    r: 1.2
  })), _circle819 || (_circle819 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 649.4,
    cy: 121.2,
    r: 1.2
  })), _circle820 || (_circle820 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 737.6,
    cy: 276.9,
    r: 0.8
  })), _circle821 || (_circle821 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 684.2,
    cy: 141.1,
    r: 0.8
  })), _circle822 || (_circle822 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 555,
    cy: 135.1,
    r: 0.8
  })), _circle823 || (_circle823 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 624,
    cy: 566.3,
    r: 0.8
  })), _circle824 || (_circle824 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 659.8,
    cy: 74.9,
    r: 0.8
  })), _circle825 || (_circle825 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 416.4,
    cy: 818.7,
    r: 0.8
  })), _circle826 || (_circle826 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 491.2,
    cy: 835.5,
    r: 2
  })), _circle827 || (_circle827 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 632.1,
    cy: 794,
    r: 2
  })), _circle828 || (_circle828 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 394.1,
    cy: 838.7,
    r: 1.2
  })), _circle829 || (_circle829 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 728.2,
    cy: 847.2,
    r: 1.2
  })), _circle830 || (_circle830 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 509.2,
    cy: 796.4,
    r: 1.2
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M591.8,3364.7l.7,4.4,4.4.6-4.4.6-.7,4.4-.7-4.4-4.4-.6,4.4-.6.7-4.4Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st174"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 547,
    cy: 3383.5,
    r: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st174"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 612.3,
    cy: 3380.8,
    r: 0.8
  }))), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.5,12133.5c-7.9-5.5-21.5,1-29.8,7.5,12.6-8.4,23.8-7.8,29.7-2,1.3,1.3,3.6.6,3.8-1.5.8-11,18.6-17,23.6-18.3-12.8,2.4-25.5,6.4-27.2,14.2Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M615.8,11692c-3.7-7.5-16.8-8.4-26-7.1,13.2-1,21.5,4.2,23.5,11.2.4,1.5,2.5,2,3.5.5,5.3-8,21.5-5,25.8-3.9-10.8-3.6-22.1-6-26.8-.8h0Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M567.8,11711.7c-3.9-5.2-14-4.1-20.8-1.8,10-2.6,17,.3,19.5,5.3.5,1.1,2.2,1.2,2.8,0,3-6.9,15.7-6.8,19.2-6.5-8.8-1.3-17.8-1.6-20.7,3.1h0Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.8,11810.2c12.4,0,23.2,6.1,28.8,15.2,4.4-2.6,9.6-4.1,15.4-4.1,14.8,0,26.8,10.2,26.8,22.8v.5c2.2-.7,4.6-1,7.1-1,12.6,0,22.8,9.1,22.8,20.3s-9.4,19.6-21.2,20.3h0s-133.8,0-133.8,0v-.7c-1.8.4-3.6.7-5.5.7-11.3,0-20.5-8.1-20.5-18.1s7.6-16.6,17.5-17.9c0-.8-.1-1.7-.1-2.6,0-13.5,11.3-24.4,25.2-24.4s7.1.8,10.2,2.1c5.9-7.9,16-13.1,27.4-13.1Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M95.3,11085c-9.1-10.3-30.2-5.9-43.9,0,20.3-7.3,35.7-2.6,41.9,7.5,1.3,2.2,4.8,2.1,5.7-.7,4.9-14.9,31.6-17.2,38.9-17.3-18.6-1-37.5,0-42.6,10.4h0Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M264,10597c-7.9-5.5-21.5,1-29.8,7.5,12.6-8.4,23.8-7.8,29.7-2,1.3,1.3,3.6.6,3.8-1.5.8-11,18.6-17,23.5-18.3-12.8,2.4-25.5,6.4-27.2,14.2h0Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M618,8608c19.8,0,36.5,11.8,40.8,27.7.7,0,1.4,0,2.1,0,13.3,0,24,9.2,24,20.6s0,.4,0,.6c15.3.7,27.4,10.6,27.4,22.8s-12,22-27.1,22.8h0c0,0-170.3,0-170.3,0-18.3,0-33.1-10.6-33.1-23.6s9.3-19.2,22.3-22.3c-.2-1.2-.3-2.3-.3-3.5,0-14.4,13.6-26.1,30.4-26.1s11,1.3,15.5,3.6c5.5-6.4,14.3-10.5,24.2-10.5s7.5.6,10.9,1.8c7.7-8.4,19.6-13.8,33-13.8h0Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M611.8,9508.1c11.6,0,21.5,5.3,25.6,12.9,1.2-.2,2.3-.3,3.6-.3,10.9,0,19.7,7.8,19.7,17.3s-7.4,16-16.9,17.2v.2h-58.4c-8.5-.2-15.3-6.3-15.3-13.8s6.2-13,14.2-13.7c.5-11,12.6-19.8,27.5-19.8h0Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M425.2,8382.9c5.9,0,11.3,2.1,15.3,5.6,2.6-1,5.4-1.5,8.3-1.5,9.9,0,18.2,5.8,21,13.9.9,0,1.7-.2,2.6-.2,11.3,0,20.5,8.3,20.5,18.6s-9.2,18.6-20.5,18.6-.7,0-1,0h0s-64.5,0-64.5,0c-.2,0-.4,0-.6,0-11.3,0-20.5-7.4-20.5-16.5s7.6-15.2,17.5-16.3c0-.7-.1-1.5-.1-2.2,0-11,9.9-20,22-20h0Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M155.9,8892.9c12.4,0,23.2,6.1,28.8,15.2,4.4-2.6,9.6-4.1,15.4-4.1,14.8,0,26.8,10.2,26.8,22.8v.5c2.2-.7,4.6-1,7.1-1,12.6,0,22.8,9.1,22.8,20.3s-9.4,19.6-21.2,20.3h0s-133.8,0-133.8,0v-.7c-1.8.4-3.6.7-5.5.7-11.3,0-20.5-8.1-20.5-18.1s7.6-16.6,17.4-17.9c0-.8-.1-1.7-.1-2.6,0-13.5,11.3-24.4,25.2-24.4s7.1.8,10.2,2.1c5.9-7.9,16-13.1,27.4-13.1h0Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M533.3,9520.7c-12.5,0-22.9,7.4-25.6,17.4-.4,0-.9,0-1.3,0-8.3,0-15.1,5.8-15.1,13v.4c-9.6.4-17.2,6.7-17.2,14.3s7.5,13.8,17,14.3h0s107,0,107,0c11.5,0,20.8-6.7,20.8-14.8s-5.9-12-14-14c.1-.7.2-1.5.2-2.2,0-9-8.6-16.4-19.1-16.4s-6.9.8-9.7,2.3c-3.4-4-9-6.6-15.2-6.6s-4.7.4-6.9,1.1c-4.8-5.3-12.3-8.7-20.7-8.7h0Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M602.2,10707.1c-12.5,0-22.9,7.4-25.7,17.4-.4,0-.9,0-1.3,0-8.3,0-15.1,5.8-15.1,13v.4c-9.6.4-17.2,6.7-17.2,14.3s7.5,13.8,17,14.3h0s107,0,107,0c11.5,0,20.8-6.7,20.8-14.8s-5.9-12-14-14c.1-.7.2-1.5.2-2.2,0-9-8.6-16.4-19.1-16.4s-6.9.8-9.7,2.3c-3.4-4-9-6.6-15.2-6.6s-4.7.4-6.9,1.1c-4.8-5.3-12.3-8.7-20.7-8.7h0Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M183.2,9153.2c-3.7-7.5-16.8-8.4-25.9-7.1,13.2-1,21.5,4.2,23.5,11.2.4,1.5,2.5,2,3.5.5,5.3-8,21.4-5,25.8-3.9-10.8-3.6-22.1-6-26.8-.8Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M597.7,9409.6c-9.1-10.3-30.2-5.9-43.9,0,20.3-7.3,35.7-2.6,41.9,7.5,1.3,2.2,4.8,2.1,5.7-.7,4.9-14.9,31.6-17.2,38.9-17.3-18.6-1-37.5,0-42.6,10.4h0Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M593.9,10172.7c-7.9-5.5-21.5,1-29.8,7.5,12.6-8.4,23.8-7.8,29.7-2,1.3,1.3,3.6.6,3.8-1.5.8-11,18.6-17,23.5-18.3-12.8,2.4-25.5,6.4-27.2,14.2Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M135.2,9172.9c-3.9-5.2-14.1-4.1-20.8-1.8,10-2.6,17,.3,19.5,5.3.5,1.1,2.2,1.2,2.8,0,3-6.9,15.7-6.8,19.2-6.5-8.8-1.3-17.8-1.6-20.6,3.1h0Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M612.8,8006.5c11.9,0,21.9,7.1,24.5,16.6.4,0,.8,0,1.3,0,8,0,14.4,5.5,14.4,12.4v.4c9.2.4,16.4,6.4,16.4,13.7s-7.2,13.2-16.2,13.6h0s-102.1,0-102.1,0c-11,0-19.8-6.3-19.8-14.2s5.6-11.5,13.4-13.4c-.1-.7-.2-1.4-.2-2.1,0-8.6,8.2-15.6,18.2-15.6s6.6.8,9.3,2.2c3.3-3.8,8.6-6.3,14.5-6.3s4.5.4,6.5,1c4.6-5,11.8-8.3,19.8-8.3h0Z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    className: "st111",
    width: 130,
    height: 60,
    transform: "translate(264.4 7609) rotate(-180) scale(2 -2)",
    xlinkHref: "ascend-scrolling-bg-1.png"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M551.8,971.1l.7,4.4,4.4.7-4.4.7-.7,4.4-.7-4.4-4.4-.7,4.4-.7.7-4.4Z"
  })), _circle831 || (_circle831 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 559.5,
    cy: 935.1,
    r: 0.8
  })), _circle832 || (_circle832 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 506.9,
    cy: 989.9,
    r: 2
  })), _circle833 || (_circle833 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 521.7,
    cy: 948.4,
    r: 0.8
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M565.2,2539.9l-.7-4.4-4.4-.6,4.4-.6.7-4.4.7,4.4,4.4.6-4.4.6-.7,4.4Z"
  })), _circle834 || (_circle834 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 557.6,
    cy: 2484.4,
    r: 2
  })), _circle835 || (_circle835 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 549.4,
    cy: 2562.1,
    r: 1.2
  })), _circle836 || (_circle836 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 619.3,
    cy: 2502.9,
    r: 1.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st176"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M524.7,5605.1l93.8-7.4s6.7-1.7,11.9-1.1c5.6.7,12.8,5.2,12.8,5.2,0,0,14.6,0,22,.8,5.4.6,8.1,1.8,8.6,2.6.7,1.2.2,2.7-6.4,4.5-3.7,1-13.8,2.3-22.2,2.7,0,0-16,2.6-36.1,2.7l-84.7,6.7c0,0-.2,0-.3,0l-49.4-.8c-.6,0-1.1-.4-1.3-1-.6-1.8-1.5-5.5.4-8.3,0,0-5-.2-6.3-.6-1.3-.4-2.3-2.6,0-3.1,2.3-.5,4-1.6,3.1-3.4l-1.2-.5.2-5.4.5-.4-.2-24.5c-1-.1-1.5-1.9.4-1.9l7.7.4,14.5,27s2.7,4.6,8.1,5.2c0,0,15.6,0,23.1.9.3,0,.7,0,1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M589.1,5606.1s-12.4-3.1-22.7-8.2-13.9-6.8-15.3-8.4c-.1-.1-.3-.2-.4-.2l-16.9,1.2c-.3,0-.6.4-.5.7l5.2,19.3,50.6-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M497.4,5607s-20.4-1.8-20.5-1.8-9.9.9-9.9.9l4.7,2.7,25.7-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M625.8,5596.6c1.5-.1,3.1-.1,4.5,0,5.6.7,12.8,5.2,12.8,5.2l-17.8-1c-.6-1.6.4-4.3.4-4.3h0Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st112"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M162.9,4110.1l-8.4-6.3,19.3-122.7c0-.3,0-.6,0-.9l-2-12.1,4.2-26.8c0-.2,0-.4,0-.6l-1-18,1.8-11.5c0-.4,0-.8,0-1.2l-1.8-6.5c-.2-.6-.5-1.1-1-1.5l.5-3.1c0-.3-.1-.5-.4-.6h-.3c0,0,2.4-15.4,2.4-15.4,0-.3-.2-.7-.5-.7-.3,0-.7.2-.7.5l-2.4,15.3h-.3c-.3,0-.5,0-.6.4l-.5,3.1c-.6.2-1.1.6-1.4,1.1l-3.7,5.6c-.2.4-.4.7-.5,1.2l-1.8,11.5-6.5,16.8c0,.2-.1.4-.2.6l-4.2,26.8-5.6,11c-.1.3-.2.6-.3.9l-19.3,122.7-9.9,3.4c-.8.3-1.3,1-1.5,1.8l-.7,4.5c-.2,1.2.6,2.4,1.8,2.6l2.7.4c0,.4,0,.8.2,1.1.4.9,1.2,1.6,2.2,1.7l2.4.4c-1.2,2.1-1.9,5.2-2.2,6.5,0,.3.1.6.4.6l6.1,1c.3,0,.6-.2.6-.4.2-1.3.5-4.5,0-6.8l6.3,1c-1.2,2.1-1.9,5.2-2.2,6.5,0,.3.1.6.4.6l6.1,1c.3,0,.6-.2.6-.4.2-1.3.5-4.5,0-6.8l6.3,1c-1.2,2.1-1.9,5.2-2.2,6.5,0,.3.1.6.4.6l6.1,1c.3,0,.6-.2.6-.4.2-1.3.5-4.5,0-6.8l2.4.4c1,.2,2-.2,2.7-1,.3-.3.5-.6.6-1l2.7.4c1.2.2,2.3-.7,2.5-1.9l.7-4.5c.1-.9-.2-1.7-.8-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M162.9,4110.1l-8.4-6.3,19.3-122.7c0-.3,0-.6,0-.9l-2-12.1,4.2-26.8c0-.2,0-.4,0-.6l-1-18,1.8-11.5c0-.4,0-.8,0-1.2l-1.8-6.5c-.2-.6-.5-1.1-1-1.5l.5-3.1c0-.3-.1-.5-.4-.6h-.3c0,0,2.4-15.4,2.4-15.4,0-.3-.2-.7-.5-.7-.3,0-.7.2-.7.5l-2.4,15.3h-.3c-.3,0-.5,0-.6.4l-.5,3.1c-.6.2-1.1.6-1.4,1.1l-3.7,5.6c-.2.4-.4.7-.5,1.2l-1.8,11.5-6.5,16.8c0,.2-.1.4-.2.6l-4.2,26.8-5.6,11c-.1.3-.2.6-.3.9l-19.3,122.7-9.9,3.4c-.8.3-1.3,1-1.5,1.8l-.7,4.5c-.2,1.2.6,2.4,1.8,2.6l2.7.4c0,.4,0,.8.2,1.1.4.9,1.2,1.6,2.2,1.7l2.4.4c-1.2,2.1-1.9,5.2-2.2,6.5,0,.3.1.6.4.6l6.1,1c.3,0,.6-.2.6-.4.2-1.3.5-4.5,0-6.8l6.3,1c-1.2,2.1-1.9,5.2-2.2,6.5,0,.3.1.6.4.6l6.1,1c.3,0,.6-.2.6-.4.2-1.3.5-4.5,0-6.8l6.3,1c-1.2,2.1-1.9,5.2-2.2,6.5,0,.3.1.6.4.6l6.1,1c.3,0,.6-.2.6-.4.2-1.3.5-4.5,0-6.8l2.4.4c1,.2,2-.2,2.7-1,.3-.3.5-.6.6-1l2.7.4c1.2.2,2.3-.7,2.5-1.9l.7-4.5c.1-.9-.2-1.7-.8-2.2h0ZM121.6,4109.3l-2.5-.4.5-3.1,5.6-2-3.6,5.4h0ZM169.4,3980.7l-3.9,24.7-12.4-1.9,3.9-24.7,12.4,1.9ZM165.2,4007.3l-.5,3.4-12.4-1.9.5-3.4,12.4,1.9ZM172.5,3910.8l-1.3,8.5-2.5-.4,1.3-8.5,1.7-2.5.8,2.9ZM167.7,3923.3l3,.5.9,16.7-9.9-1.6,6-15.6ZM160.4,3947l10.1,1.6-.6,3.6-10.1-1.6.6-3.6ZM159.5,3952.6l10.1,1.6-2.1,13.2-10.1-1.6,2.1-13.2ZM151.5,3977.9l2.2.3-3.9,24.7-2.2-.3,3.9-24.7ZM147.3,4004.5l2.2.3-.5,3.4-2.2-.3.5-3.4ZM146.4,4068.8l-8.9-1.4,5.3-33.9,8.9,1.4-5.3,33.9ZM143.1,4031.6l2.9-18.6,17.9,2.8-2.9,18.6-17.9-2.8ZM160.7,4036.3l-5.3,33.9-2.3-.4,5.3-33.9,2.3.4ZM142.7,4113.8l6.2-39.4,5.6.9-4.5,28.6c0,.4,0,.9,0,1.3l1.3,4.8,1.1,5.5-9.9-1.6ZM160.1,4115.3l-2.5-.4-1.8-6.2,4.8,3.6-.5,3.1h0Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st115"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M662.6,556.3c0-.1-.2-.2-.3-.3l-20.9-6.3c-.2,0-.5,0-.6.3l-1.5,2.9-.9-.3,1.1-2.2c0-.1,0-.3,0-.5,0-.1-.1-.2-.2-.2l-2.7-3.3c1.4-.7,2.4-2.4,2.4-4.4s-1.8-4.8-3.9-4.8-.8,0-1.1.2c-2.3.4-4.3,2.7-4.3,5s.2,1.2.5,1.8h-.3c0-.1-.1-.1-.2-.1h0c-.2,0-.4.1-.5.3l-2,4.3-1.2-.4,1.5-3.5c0-.1,0-.3,0-.4,0-.1-.2-.2-.3-.3l-29.7-8.8c-.2,0-.5,0-.6.3l-3,7.2c0,.1,0,.3,0,.4,0,.1.2.2.3.3l8.7,2.6s0,0,.1,0c0,0,.2,0,.2,0h0l20.7,6.1s0,0,.1,0c.2,0,.4-.1.5-.3l1.2-2.8,1.1.4-.6,1.3c0,.1,0,.3,0,.4l1.6,4.4c0,0,0,.2.1.2,0,.1.2.2.3.2l7.3,1.7s0,0,.1,0c.2,0,.4-.1.5-.3l1.9-3.9s0,0,0,0l.9.3-1.2,2.3c0,.1,0,.3,0,.4,0,.1.2.2.3.3l20.9,6.3s0,0,.1,0c.2,0,.4-.1.5-.3l3.1-6.1c0-.1,0-.3,0-.4h0ZM624,544.2l2,.6-.5,1.2-2-.6.5-1.2h0ZM621.1,543.3l1.7.5-.5,1.2-1.7-.5.5-1.2ZM618.1,542.4l1.8.5-.5,1.2-1.8-.5.5-1.2ZM615.1,541.6l1.8.5-.5,1.2-1.8-.5.5-1.2ZM612.1,540.7l1.7.5-.5,1.3-1.8-.5.5-1.3ZM609.1,539.8l1.8.5-.5,1.3-1.8-.5.5-1.3h0ZM606.1,538.9l1.7.5-.5,1.3-1.8-.5.5-1.3ZM603.2,538l1.8.5-.5,1.3-1.8-.5.5-1.3ZM600.2,537.2l1.8.5-.5,1.3-1.8-.5.5-1.3ZM597.2,536.3l1.7.5-.5,1.3-1.7-.5.6-1.3ZM596.6,543.1l-1.8-.5.6-1.4,1.8.5-.6,1.4ZM595.7,539.9l.5-1.1,1.7.5-.5,1.2-1.7-.5h0ZM599.6,543.9l-1.8-.5.6-1.4,1.8.5-.6,1.5ZM598.7,540.8l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM602.6,544.8l-1.8-.5.6-1.5,1.8.5-.6,1.5ZM601.7,541.7l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM605.5,545.7l-1.7-.5.6-1.5,1.8.5-.6,1.5h0ZM604.7,542.5l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM608.5,546.6l-1.8-.5.6-1.5,1.8.5-.6,1.5h0ZM607.9,543.4l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM611.5,547.5l-1.7-.5.6-1.5,1.8.5-.6,1.5ZM610.9,544.3l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM614.5,548.4l-1.8-.5.6-1.5,1.8.5-.6,1.5h0ZM613.8,545.1l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM617.5,549.2l-1.8-.5.6-1.5,1.8.5-.6,1.5ZM616.8,546l.5-1.2,1.8.5-.5,1.2-1.8-.5ZM620.5,550.1l-1.7-.5.6-1.5,1.7.5-.6,1.5ZM619.8,546.9l.5-1.2,1.7.5-.5,1.2-1.7-.5ZM623.6,551l-1.9-.6.6-1.5,1.9.6-.7,1.6h0ZM622.8,547.7l.5-1.2,2,.6-.5,1.1-1.9-.6h0ZM637.5,549.1l-5.5-1.6-1.3-2.2.8.2c1,.7,2.2,1,3.4,1.1l.9.3,1.7,2.2h0ZM635.1,538.2c1.6,0,2.8,1.7,2.8,3.7s-1.3,3.7-2.8,3.7-.2,0-.3,0l-.7-.2c-.7-.4-1.3-1.1-1.6-2l3.3-.4c.3,0,.5-.3.5-.6,0-.3-.3-.5-.6-.5l-3.4.4c0-.1,0-.2,0-.3,0-2,1.3-3.7,2.8-3.7h0ZM631.4,540.2c-.2.5-.2,1.1-.2,1.6,0,.9.2,1.8.6,2.5-.6-.5-1-1.3-1-2.1s.3-1.4.7-2.1ZM627.1,551l2.5-5.3,1.4,2.4-2.8,5.9-1.1-2.9h0ZM635.2,556.5l-6.2-1.4,3-6.4,6.2,1.8-3,6ZM657.8,555.8l1.3.4-.5,1-1.3-.4.5-1h0ZM658.2,558.1l-.7,1.3-1.3-.4.7-1.3,1.3.4ZM655.4,555l1.4.4-.5,1-1.4-.4.5-1h0ZM655.8,557.4l-.7,1.3-1.4-.4.7-1.3,1.4.4ZM653.1,554.3l1.3.4-.5,1-1.3-.4.5-1h0ZM653.5,556.6l-.6,1.3-1.3-.4.6-1.2,1.3.4h0ZM650.8,553.6l1.4.4-.5,1-1.4-.4.5-1h0ZM651.1,555.9l-.6,1.2-1.4-.4.6-1.2,1.4.4h0ZM648.5,552.9l1.3.4-.5,1-1.3-.4.5-1h0ZM648.8,555.2l-.6,1.2-1.3-.4.6-1.2,1.3.4h0ZM646.1,552.2l1.4.4-.5,1-1.4-.4.5-1ZM646.5,554.5l-.6,1.2-1.4-.4.6-1.2,1.4.4ZM643.7,551.5l1.4.4-.5,1-1.4-.4.5-1h0ZM644.1,553.8l-.6,1.2-1.4-.4.6-1.2,1.4.4h0ZM641.5,550.8l1.3.4-.5,1-1.3-.4.5-1ZM641.8,553.1l-.6,1.2-1.2-.4.6-1.2,1.3.4h0ZM640,556.4l-1.2-.4.6-1.2,1.2.4-.6,1.2ZM642.4,557.1l-1.4-.4.6-1.2,1.4.4-.6,1.2ZM644.8,557.8l-1.4-.4.6-1.2,1.4.4-.6,1.2ZM647.1,558.5l-1.3-.4.6-1.2,1.3.4-.6,1.2ZM649.4,559.2l-1.4-.4.6-1.1,1.4.4-.6,1.1ZM651.8,559.9l-1.3-.4.6-1.1,1.3.4-.6,1.1ZM654.1,560.7l-1.4-.4.6-1.1,1.4.4-.6,1.1h0ZM656.5,561.4l-1.3-.4.6-1.1,1.3.4-.6,1.1h0ZM658.7,562l-1.3-.4.6-1.1,1.3.4-.6,1.1h0ZM659.8,560l-1.3-.4.7-1.3,1.3.4-.6,1.3h0ZM660.9,557.8l-1.3-.4.5-1,1.2.4-.5,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M624,544.2l2,.6-.5,1.2-2-.6.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M621.1,543.3l1.7.5-.5,1.2-1.7-.5.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M618.1,542.4l1.8.5-.5,1.2-1.8-.5.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M615.1,541.6l1.8.5-.5,1.2-1.8-.5.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M612.1,540.7l1.7.5-.5,1.3-1.8-.5.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M609.1,539.8l1.8.5-.5,1.3-1.8-.5.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M606.1,538.9l1.7.5-.5,1.3-1.8-.5.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M603.2,538l1.8.5-.5,1.3-1.8-.5.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M600.2,537.2l1.8.5-.5,1.3-1.8-.5.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M597.2,536.3l1.7.5-.5,1.3-1.7-.5.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M596.6,543.1l-1.8-.5.6-1.4,1.8.5-.6,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M595.7,539.9l.5-1.1,1.7.5-.5,1.2-1.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M599.6,543.9l-1.8-.5.6-1.4,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M598.7,540.8l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M602.6,544.8l-1.8-.5.6-1.5,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M601.7,541.7l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M605.5,545.7l-1.7-.5.6-1.5,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M604.7,542.5l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M608.5,546.6l-1.8-.5.6-1.5,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M607.9,543.4l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M611.5,547.5l-1.7-.5.6-1.5,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M610.9,544.3l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M614.5,548.4l-1.8-.5.6-1.5,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M613.8,545.1l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M617.5,549.2l-1.8-.5.6-1.5,1.8.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M616.8,546l.5-1.2,1.8.5-.5,1.2-1.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M620.5,550.1l-1.7-.5.6-1.5,1.7.5-.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M619.8,546.9l.5-1.2,1.7.5-.5,1.2-1.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M623.6,551l-1.9-.6.6-1.5,1.9.6-.7,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M622.8,547.7l.5-1.2,2,.6-.5,1.1-1.9-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M637.5,549.1l-5.5-1.6-1.3-2.2.8.2c1,.7,2.2,1,3.4,1.1l.9.3,1.7,2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M635.1,538.2c1.6,0,2.8,1.7,2.8,3.7s-1.3,3.7-2.8,3.7-.2,0-.3,0l-.7-.2c-.7-.4-1.3-1.1-1.6-2l3.3-.4c.3,0,.5-.3.5-.6,0-.3-.3-.5-.6-.5l-3.4.4c0-.1,0-.2,0-.3,0-2,1.3-3.7,2.8-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M631.4,540.2c-.2.5-.2,1.1-.2,1.6,0,.9.2,1.8.6,2.5-.6-.5-1-1.3-1-2.1s.3-1.4.7-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M627.1,551l2.5-5.3,1.4,2.4-2.8,5.9-1.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M635.2,556.5l-6.2-1.4,3-6.4,6.2,1.8-3,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M657.8,555.8l1.3.4-.5,1-1.3-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M658.2,558.1l-.7,1.3-1.3-.4.7-1.3,1.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M655.4,555l1.4.4-.5,1-1.4-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M655.8,557.4l-.7,1.3-1.4-.4.7-1.3,1.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M653.1,554.3l1.3.4-.5,1-1.3-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M653.5,556.6l-.6,1.3-1.3-.4.6-1.2,1.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M650.8,553.6l1.4.4-.5,1-1.4-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M651.1,555.9l-.6,1.2-1.4-.4.6-1.2,1.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M648.5,552.9l1.3.4-.5,1-1.3-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M648.8,555.2l-.6,1.2-1.3-.4.6-1.2,1.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M646.1,552.2l1.4.4-.5,1-1.4-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M646.5,554.5l-.6,1.2-1.4-.4.6-1.2,1.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M643.7,551.5l1.4.4-.5,1-1.4-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M644.1,553.8l-.6,1.2-1.4-.4.6-1.2,1.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M641.5,550.8l1.3.4-.5,1-1.3-.4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M641.8,553.1l-.6,1.2-1.2-.4.6-1.2,1.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M640,556.4l-1.2-.4.6-1.2,1.2.4-.6,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M642.4,557.1l-1.4-.4.6-1.2,1.4.4-.6,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M644.8,557.8l-1.4-.4.6-1.2,1.4.4-.6,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M647.1,558.5l-1.3-.4.6-1.2,1.3.4-.6,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M649.4,559.2l-1.4-.4.6-1.1,1.4.4-.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M651.8,559.9l-1.3-.4.6-1.1,1.3.4-.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M654.1,560.7l-1.4-.4.6-1.1,1.4.4-.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M656.5,561.4l-1.3-.4.6-1.1,1.3.4-.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M658.7,562l-1.3-.4.6-1.1,1.3.4-.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M659.8,560l-1.3-.4.7-1.3,1.3.4-.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M660.9,557.8l-1.3-.4.5-1,1.2.4-.5,1Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st113"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M66.6,1446.2c0,.1,0,.3,0,.4l3.1,6.1c0,.2.3.3.5.3s0,0,.1,0l20.9-6.3c.1,0,.3-.1.3-.3,0-.1,0-.3,0-.4l-1.2-2.3.9-.3s0,0,0,0l1.9,3.9c0,.2.3.3.5.3s0,0,.1,0l7.3-1.7c.1,0,.2-.1.3-.2,0,0,.1-.1.1-.2l1.6-4.4c0-.1,0-.3,0-.4l-.6-1.3,1.1-.4,1.2,2.8c0,.2.3.3.5.3s0,0,.1,0l20.7-6.1h0c0,0,.2,0,.2,0,0,0,0,0,.1,0l8.7-2.6c.1,0,.3-.1.3-.3,0-.1,0-.3,0-.4l-3-7.2c-.1-.2-.4-.4-.6-.3l-29.7,8.8c-.1,0-.3.1-.3.3,0,.1,0,.3,0,.4l1.5,3.5-1.2.4-2-4.3c0-.2-.3-.3-.5-.3h0c0,0-.1,0-.2,0h-.3c.3-.4.5-1,.5-1.7,0-2.3-2-4.6-4.3-5-.4-.1-.7-.2-1.1-.2-2.2,0-3.9,2.1-3.9,4.8s1,3.7,2.4,4.4l-2.7,3.3c0,0-.2.1-.2.2,0,.1,0,.3,0,.5l1.1,2.2-.9.3-1.5-2.9c-.1-.2-.4-.3-.6-.3l-20.9,6.3c-.1,0-.3.1-.3.3h0ZM105.2,1434.1l.5,1.2-2,.6-.5-1.2,2-.6h0ZM108.6,1434.4l-1.7.5-.5-1.2,1.7-.5.5,1.2ZM111.6,1433.5l-1.8.5-.5-1.2,1.8-.5.5,1.2ZM114.6,1432.7l-1.8.5-.5-1.2,1.8-.5.5,1.2ZM117.6,1431.8l-1.8.5-.5-1.3,1.7-.5.5,1.3ZM120.1,1429.7l.5,1.3-1.8.5-.5-1.3,1.8-.5h0ZM123.6,1430.1l-1.8.5-.5-1.3,1.7-.5.5,1.3ZM126.6,1429.2l-1.8.5-.5-1.3,1.8-.5.5,1.3ZM129.6,1428.3l-1.8.5-.5-1.3,1.8-.5.5,1.3ZM132.5,1427.5l-1.7.5-.5-1.3,1.7-.5.6,1.3ZM132,1431.5l1.8-.5.6,1.4-1.8.5-.6-1.4ZM133.5,1429.8l-1.7.5-.5-1.2,1.7-.5.5,1.1h0ZM129,1432.3l1.8-.5.6,1.4-1.8.5-.6-1.5ZM128.8,1431.2l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM126,1433.2l1.8-.5.6,1.5-1.8.5-.6-1.5ZM125.8,1432l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM123.7,1435.6l-.6-1.5,1.8-.5.6,1.5-1.7.5h0ZM122.8,1432.9l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM120.7,1436.4l-.6-1.5,1.8-.5.6,1.5-1.8.5h0ZM119.6,1433.8l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM117.1,1435.8l1.8-.5.6,1.5-1.7.5-.6-1.5ZM116.6,1434.6l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM114.7,1438.2l-.6-1.5,1.8-.5.6,1.5-1.8.5h0ZM113.6,1435.5l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM111.1,1437.6l1.8-.5.6,1.5-1.8.5-.6-1.5ZM110.6,1436.4l-.5-1.2,1.8-.5.5,1.2-1.8.5ZM108.1,1438.4l1.7-.5.6,1.5-1.7.5-.6-1.5ZM107.6,1437.2l-.5-1.2,1.7-.5.5,1.2-1.7.5ZM105.6,1440.9l-.7-1.6,1.9-.6.6,1.5-1.9.6h0ZM106.4,1437.6l-1.9.6-.5-1.1,2-.6.5,1.2h0ZM91.7,1439l1.7-2.2.9-.3c1.2,0,2.4-.4,3.4-1.1l.8-.2-1.3,2.2-5.5,1.6h0ZM94.1,1428c1.6,0,2.8,1.7,2.8,3.7s0,.2,0,.3l-3.4-.4c-.3,0-.6.2-.6.5,0,.3.2.6.5.6l3.3.4c-.3.9-.9,1.7-1.6,2l-.7.2c-.1,0-.2,0-.3,0-1.6,0-2.8-1.7-2.8-3.7s1.3-3.7,2.8-3.7h0ZM98.5,1432.2c0,.8-.4,1.5-1,2.1.4-.7.6-1.6.6-2.5s0-1.1-.2-1.6c.4.6.7,1.3.7,2.1ZM102.1,1440.9l-1.1,2.9-2.8-5.9,1.4-2.4,2.5,5.3h0ZM91,1440.3l6.2-1.8,3,6.4-6.2,1.4-3-6ZM71.4,1445.6l.5,1-1.3.4-.5-1,1.3-.4h0ZM72.4,1447.5l.7,1.3-1.3.4-.7-1.3,1.3-.4ZM73.8,1444.9l.5,1-1.4.4-.5-1,1.4-.4h0ZM74.8,1446.8l.7,1.3-1.4.4-.7-1.3,1.4-.4ZM76.1,1444.2l.5,1-1.3.4-.5-1,1.3-.4h0ZM75.7,1446.5l1.3-.4.6,1.2-1.3.4-.6-1.3h0ZM78.4,1443.5l.5,1-1.4.4-.5-1,1.4-.4h0ZM78.1,1445.8l1.4-.4.6,1.2-1.4.4-.6-1.2h0ZM80.8,1442.8l.5,1-1.3.4-.5-1,1.3-.4h0ZM80.4,1445.1l1.3-.4.6,1.2-1.3.4-.6-1.2h0ZM83.6,1443l-1.4.4-.5-1,1.4-.4.5,1ZM84.1,1444l.6,1.2-1.4.4-.6-1.2,1.4-.4ZM85.5,1441.4l.5,1-1.4.4-.5-1,1.4-.4h0ZM85.1,1443.7l1.4-.4.6,1.2-1.4.4-.6-1.2h0ZM88.2,1441.6l-1.3.4-.5-1,1.3-.4.5,1ZM87.4,1442.9l1.3-.4.6,1.2-1.2.4-.6-1.2h0ZM88.6,1445.1l1.2-.4.6,1.2-1.2.4-.6-1.2ZM86.2,1445.8l1.4-.4.6,1.2-1.4.4-.6-1.2ZM83.8,1446.5l1.4-.4.6,1.2-1.4.4-.6-1.2ZM81.5,1447.2l1.3-.4.6,1.2-1.3.4-.6-1.2ZM79.2,1448l1.4-.4.6,1.1-1.4.4-.6-1.1ZM76.9,1448.7l1.3-.4.6,1.1-1.3.4-.6-1.1ZM75.1,1450.5l-.6-1.1,1.4-.4.6,1.1-1.4.4h0ZM72.7,1451.2l-.6-1.1,1.3-.4.6,1.1-1.3.4h0ZM70.5,1451.9l-.6-1.1,1.3-.4.6,1.1-1.3.4h0ZM69.4,1449.9l-.6-1.3,1.3-.4.7,1.3-1.3.4h0ZM68.3,1447.7l-.5-1,1.2-.4.5,1-1.3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M105.7,1435.3l-2,.6-.5-1.2,2-.6.5,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M108.6,1434.4l-1.7.5-.5-1.2,1.7-.5.5,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M111.6,1433.5l-1.8.5-.5-1.2,1.8-.5.5,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M114.6,1432.7l-1.8.5-.5-1.2,1.8-.5.5,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117.6,1431.8l-1.8.5-.5-1.3,1.7-.5.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M120.6,1430.9l-1.8.5-.5-1.3,1.8-.5.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M123.6,1430.1l-1.8.5-.5-1.3,1.7-.5.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M126.6,1429.2l-1.8.5-.5-1.3,1.8-.5.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M129.6,1428.3l-1.8.5-.5-1.3,1.8-.5.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M132.5,1427.5l-1.7.5-.5-1.3,1.7-.5.6,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M132,1431.5l1.8-.5.6,1.4-1.8.5-.6-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M131.8,1430.3l-.5-1.2,1.7-.5.5,1.1-1.7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M129,1432.3l1.8-.5.6,1.4-1.8.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M128.8,1431.2l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M126,1433.2l1.8-.5.6,1.5-1.8.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M125.8,1432l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M123,1434.1l1.8-.5.6,1.5-1.7.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M122.8,1432.9l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M120.1,1435l1.8-.5.6,1.5-1.8.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M119.6,1433.8l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M117.1,1435.8l1.8-.5.6,1.5-1.7.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M116.6,1434.6l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M114.1,1436.7l1.8-.5.6,1.5-1.8.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M113.6,1435.5l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M111.1,1437.6l1.8-.5.6,1.5-1.8.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M110.6,1436.4l-.5-1.2,1.8-.5.5,1.2-1.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M108.1,1438.4l1.7-.5.6,1.5-1.7.5-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M107.6,1437.2l-.5-1.2,1.7-.5.5,1.2-1.7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M105,1439.3l1.9-.6.6,1.5-1.9.6-.7-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M104.5,1438.2l-.5-1.1,2-.6.5,1.2-1.9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M91.7,1439l1.7-2.2.9-.3c1.2,0,2.4-.4,3.4-1.1l.8-.2-1.3,2.2-5.5,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M94.1,1428c1.6,0,2.8,1.7,2.8,3.7s0,.2,0,.3l-3.4-.4c-.3,0-.6.2-.6.5,0,.3.2.6.5.6l3.3.4c-.3.9-.9,1.7-1.6,2l-.7.2c-.1,0-.2,0-.3,0-1.6,0-2.8-1.7-2.8-3.7s1.3-3.7,2.8-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M98.5,1432.2c0,.8-.4,1.5-1,2.1.4-.7.6-1.6.6-2.5s0-1.1-.2-1.6c.4.6.7,1.3.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M101,1443.8l-2.8-5.9,1.4-2.4,2.5,5.3-1.1,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M91,1440.3l6.2-1.8,3,6.4-6.2,1.4-3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M71.9,1446.6l-1.3.4-.5-1,1.3-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M72.4,1447.5l.7,1.3-1.3.4-.7-1.3,1.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M74.3,1445.9l-1.4.4-.5-1,1.4-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M74.8,1446.8l.7,1.3-1.4.4-.7-1.3,1.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M76.6,1445.2l-1.3.4-.5-1,1.3-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M77.1,1446.1l.6,1.2-1.3.4-.6-1.3,1.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M78.9,1444.5l-1.4.4-.5-1,1.4-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M79.4,1445.4l.6,1.2-1.4.4-.6-1.2,1.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M81.3,1443.8l-1.3.4-.5-1,1.3-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M81.7,1444.7l.6,1.2-1.3.4-.6-1.2,1.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M83.6,1443l-1.4.4-.5-1,1.4-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M84.1,1444l.6,1.2-1.4.4-.6-1.2,1.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M86,1442.3l-1.4.4-.5-1,1.4-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M86.5,1443.2l.6,1.2-1.4.4-.6-1.2,1.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M88.2,1441.6l-1.3.4-.5-1,1.3-.4.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M88.7,1442.6l.6,1.2-1.2.4-.6-1.2,1.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M88.6,1445.1l1.2-.4.6,1.2-1.2.4-.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M86.2,1445.8l1.4-.4.6,1.2-1.4.4-.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M83.8,1446.5l1.4-.4.6,1.2-1.4.4-.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M81.5,1447.2l1.3-.4.6,1.2-1.3.4-.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M79.2,1448l1.4-.4.6,1.1-1.4.4-.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M76.9,1448.7l1.3-.4.6,1.1-1.3.4-.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M74.5,1449.4l1.4-.4.6,1.1-1.4.4-.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M72.2,1450.1l1.3-.4.6,1.1-1.3.4-.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M69.9,1450.8l1.3-.4.6,1.1-1.3.4-.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M68.8,1448.6l1.3-.4.7,1.3-1.3.4-.6-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M67.8,1446.7l1.2-.4.5,1-1.3.4-.5-1Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -6.7,
    y1: 888.8,
    x2: 743.3,
    y2: 888.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st110",
    x: 288.1,
    y: 856.1,
    width: 160.4,
    height: 67.2,
    rx: 5.6,
    ry: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M318.4,882.7h-2.4l-5.3-7h-3v7h-2v-15.7h2v6.7h3l5-6.7h2.3l-5.6,7.6,6.1,8.1ZM323.5,882.9c-1,0-1.9-.2-2.7-.7-.8-.5-1.4-1.2-1.9-2.1-.5-.9-.7-1.9-.7-3.1s.2-2.2.7-3c.5-.9,1.1-1.6,1.9-2.1.8-.5,1.7-.7,2.7-.7s1.6.2,2.3.6c.7.4,1.3.9,1.7,1.5h.1v-1.9h1.8v11.3h-1.8v-1.9h-.1c-.4.6-.9,1.2-1.7,1.5-.7.4-1.5.6-2.3.6ZM323.9,881.2c1.1,0,1.9-.4,2.6-1.1.7-.7,1-1.8,1-3s-.3-2.3-1-3c-.7-.7-1.5-1.1-2.6-1.1s-2,.4-2.7,1.1c-.7.7-1,1.7-1,3s.3,2.3,1,3,1.6,1.1,2.7,1.1ZM324.9,870h-1.5l1.4-3.2h2.1l-2.1,3.2ZM332.2,882.7v-11.3h1.8v1.8h.1c.3-.6.7-1,1.3-1.4.6-.4,1.3-.6,2.1-.6h1.6v1.8h-1.6c-1,0-1.8.3-2.4,1-.6.7-.9,1.5-.9,2.6v6.1h-1.9ZM340.4,882.7v-11.3h1.8v1.7h.1c.3-.5.8-1,1.4-1.4.6-.4,1.3-.6,2.1-.6s1.7.2,2.3.7c.6.4,1,1,1.2,1.6h.1c.4-.6.9-1.2,1.5-1.6.6-.4,1.4-.7,2.4-.7s2.2.4,3,1.2c.7.8,1.1,2,1.1,3.5v6.8h-1.9v-6.6c0-1-.2-1.8-.7-2.4-.4-.6-1.1-.8-1.9-.8s-1.7.3-2.2.9c-.6.6-.9,1.4-.9,2.5v6.4h-1.9v-6.6c0-1-.2-1.8-.7-2.4-.4-.6-1.1-.8-1.9-.8s-1.6.3-2.2.9c-.6.6-.9,1.5-.9,2.5v6.4h-1.9ZM364.6,882.9c-1,0-1.9-.2-2.7-.7-.8-.5-1.4-1.2-1.9-2.1-.5-.9-.7-1.9-.7-3.1s.2-2.2.7-3c.5-.9,1.1-1.6,1.9-2.1.8-.5,1.7-.7,2.7-.7s1.6.2,2.3.6c.7.4,1.3.9,1.7,1.5h.1v-1.9h1.8v11.3h-1.8v-1.9h-.1c-.4.6-.9,1.2-1.7,1.5-.7.4-1.5.6-2.3.6ZM365,881.2c1.1,0,1.9-.4,2.6-1.1.7-.7,1-1.8,1-3s-.3-2.3-1-3c-.7-.7-1.5-1.1-2.6-1.1s-2,.4-2.7,1.1c-.7.7-1,1.7-1,3s.3,2.3,1,3c.7.7,1.6,1.1,2.7,1.1ZM366,870h-1.5l1.4-3.2h2.1l-2.1,3.2ZM373.3,882.7v-11.3h1.8v1.8h.1c.4-.6.9-1.1,1.6-1.5.7-.4,1.4-.6,2.3-.6,1.4,0,2.4.4,3.2,1.3.8.8,1.2,2,1.2,3.5v6.7h-1.9v-6.4c0-1.1-.2-1.9-.7-2.5-.5-.6-1.2-.9-2.2-.9s-1.9.3-2.5,1c-.7.7-1,1.5-1,2.6v6.2h-1.9ZM402,882.7h-10.2v-15.7h2v13.7h8.2v1.9ZM405.5,882.7h-1.9v-11.3h1.9v11.3ZM404.5,869.7c-.3,0-.6-.1-.9-.3-.2-.2-.3-.5-.3-.9s.1-.6.3-.9c.2-.2.5-.3.9-.3s.6.1.8.4c.2.2.4.5.4.8s-.1.6-.4.9c-.2.2-.5.3-.8.3ZM408.4,882.7v-11.3h1.8v1.8h.1c.4-.6.9-1.1,1.6-1.5.7-.4,1.4-.6,2.3-.6,1.4,0,2.4.4,3.2,1.3.8.8,1.2,2,1.2,3.5v6.7h-1.9v-6.4c0-1.1-.2-1.9-.7-2.5-.5-.6-1.2-.9-2.2-.9s-1.9.3-2.5,1c-.7.7-1,1.5-1,2.6v6.2h-1.9ZM432,877.6h-9.5c.1,1.1.5,1.9,1.2,2.6.7.7,1.6,1,2.6,1s1.6-.2,2.2-.6c.6-.4,1-.9,1.3-1.6h1.9c-.3,1.1-1,2-1.9,2.7-.9.7-2.1,1.1-3.5,1.1s-2.1-.3-3-.8c-.9-.5-1.6-1.2-2.1-2.1-.5-.9-.8-1.9-.8-3s.3-2.1.8-3c.5-.9,1.2-1.6,2.1-2.1.9-.5,1.9-.8,3-.8s2,.3,2.9.8c.9.5,1.5,1.2,2,2.1.5.9.8,1.9.8,3.1v.4ZM426.3,872.9c-1,0-1.8.3-2.5.9-.7.6-1.1,1.4-1.3,2.3h7.5c-.2-.9-.6-1.7-1.3-2.3-.7-.6-1.5-.9-2.5-.9ZM332.4,900.9c1.2,0,2.3.2,3.2.7.9.5,1.7,1.1,2.2,2,.5.8.8,1.8.8,2.8s-.3,2-.8,2.8c-.5.8-1.2,1.5-2.2,2-.9.5-2,.7-3.2.7s-2.3-.2-3.2-.7c-.9-.5-1.6-1.2-2.1-2-.5-.8-.8-1.8-.8-2.8s.6-2.9,1.7-4.4l4.7-6h2.5l-3.9,5c.4,0,.9-.1,1.3-.1ZM332.4,910.1c1.3,0,2.2-.3,3-1,.7-.7,1.1-1.6,1.1-2.6s-.4-1.9-1.1-2.6c-.7-.7-1.7-1-3-1s-2.2.3-3,1c-.7.7-1.1,1.5-1.1,2.6s.4,2,1.1,2.6c.7.7,1.7,1,3,1ZM339.5,911.7v-2.9l6.4-4.3c.9-.6,1.6-1.2,2-1.8.4-.6.6-1.3.6-2s-.3-1.6-.9-2.1c-.6-.5-1.3-.8-2.3-.8s-1.9.3-2.5.9c-.6.6-1,1.3-1.1,2.3h-2.1c0-.9.3-1.7.7-2.5.4-.8,1-1.4,1.9-1.9.9-.5,1.9-.7,3.1-.7s2,.2,2.8.6c.8.4,1.4,1,1.8,1.7.4.7.6,1.5.6,2.4s-.3,2.1-.8,2.9c-.5.9-1.5,1.7-2.8,2.6l-4.8,3.3v.5h8.8v1.9h-11.5ZM358.3,911.7v-11.3h1.8v1.7h.1c.3-.5.8-1,1.4-1.4.6-.4,1.3-.6,2.1-.6s1.7.2,2.3.7,1,1,1.2,1.6h.1c.4-.6.9-1.2,1.5-1.6.6-.4,1.4-.7,2.4-.7s2.2.4,3,1.2c.7.8,1.1,2,1.1,3.5v6.8h-1.9v-6.6c0-1-.2-1.8-.7-2.4-.4-.6-1.1-.8-1.9-.8s-1.7.3-2.2.9c-.6.6-.9,1.4-.9,2.5v6.4h-1.9v-6.6c0-1-.2-1.8-.7-2.4-.4-.6-1.1-.8-1.9-.8s-1.6.3-2.2.9c-.6.6-.9,1.5-.9,2.5v6.4h-1.9ZM380,911.7h-1.9v-11.3h1.9v11.3ZM379,898.7c-.3,0-.6-.1-.9-.3-.2-.2-.3-.5-.3-.9s.1-.6.3-.9c.2-.2.5-.3.9-.3s.6.1.8.4c.2.2.4.5.4.8s-.1.6-.4.9c-.2.2-.5.3-.8.3ZM387.5,911.7h-4.5v-15.7h1.9v14h2.6v1.7ZM399.5,906.6h-9.5c.1,1.1.5,1.9,1.2,2.6.7.7,1.6,1,2.6,1s1.6-.2,2.2-.6c.6-.4,1-.9,1.3-1.6h1.9c-.3,1.1-1,2-1.9,2.7-.9.7-2.1,1.1-3.5,1.1s-2.1-.3-3-.8c-.9-.5-1.6-1.2-2.1-2.1-.5-.9-.8-1.9-.8-3s.3-2.1.8-3c.5-.9,1.2-1.6,2.1-2.1.9-.5,1.9-.8,3-.8s2,.3,2.9.8c.9.5,1.5,1.2,2,2.1.5.9.8,1.9.8,3.1v.4ZM393.8,901.9c-1,0-1.8.3-2.5.9-.7.6-1.1,1.4-1.3,2.3h7.5c-.2-.9-.6-1.7-1.3-2.3-.7-.6-1.5-.9-2.5-.9ZM405.7,911.9c-1.1,0-2-.2-2.7-.5-.7-.3-1.3-.8-1.7-1.3-.4-.6-.6-1.2-.6-1.9h1.9c0,.6.4,1.1.9,1.5.5.3,1.2.5,2.2.5s1.7-.1,2.2-.4c.5-.3.7-.7.7-1.2s-.2-.9-.7-1.1c-.5-.2-1.2-.5-2.3-.7-.9-.2-1.7-.4-2.3-.6-.6-.2-1.1-.5-1.5-1-.4-.4-.6-1.1-.6-1.8s.2-1.1.5-1.6c.4-.5.9-.9,1.5-1.1.7-.3,1.5-.4,2.4-.4s1.9.2,2.6.5c.7.3,1.2.8,1.6,1.3.3.5.5,1,.5,1.6h-1.9c-.2-1.1-1.1-1.7-2.8-1.7s-1.5.1-1.9.4c-.4.3-.6.6-.6,1.1s.1.6.4.9c.3.2.6.4,1,.5s.9.3,1.6.4c.9.2,1.7.4,2.3.6.6.2,1.1.5,1.5,1,.4.4.6,1.1.6,1.8s-.4,1.8-1.3,2.4c-.8.6-2,.9-3.6.9Z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "st114"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M44.8,9896.5c.3,3.9,13.7,13.3,37.1,15.3,23.4,2,90.3,10.4,90.3,10.4,0,0,24.6.3,33.6-1.6,9-2,28.7-8.5,28.7-8.5l1.6-5.5-3.4-2.6,10.9-49.8-5.7-.5c-2-.2-4,.7-5.3,2.3l-32.4,40.1s-21.6-2-47.4-5.2c-33.6-4.1-74.5-9.3-85.2-6.8-10.5,2.5-12.6,5.8-12.6,5.8,0,0-10.4,2.9-10.1,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M155.2,9904.6l79.1-19.8c1.8-.5,3.4-1.6,4.6-3.1l9.8-13.6,3.1-.2-6,14.3c-.9,2.1-2.6,3.8-4.7,4.5l-69.5,25.4s-8.9,2.1-16.9-2.7c-1.9-1.1-1.5-4.2.6-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M145.8,9913.4s6-3.1,14.9-1.3c8.9,1.8,13.5,4.6,13.5,4.6,0,0,2.2,1.9,1.9,5.3-.1,1.1-.8,2-1.6,2.9-2.2,2.2-5.2,3.2-8.3,3-5.2-.5-14.9-1.5-19.9-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M146.2,9924.7c1.7,0,3.1-2.5,3.1-5.6s-1.4-5.6-3.1-5.6-3.1,2.5-3.1,5.6,1.4,5.6,3.1,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M226.8,9905.4l34.9-6.6,3.3.3-31.4,9.2s-7.2-.8-6.8-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M77.2,9889.8l-11.8-4.9c-6,1.7-8.7,3.5-9.9,4.5l17.6,4.8,4.1-4.4Z"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "st116"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M581.2,1862.2l-5.7,2.9,1.3,2.5,5.7-2.9-1.3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M583.7,1866.9l-5.7,2.9,1.6,3,5.7-2.9-1.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M586.4,1872.1l-5.7,2.9,1.5,2.9,5.7-2.9-1.5-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M572,1899.8c-1.6-.5-2.9-1.6-3.7-3.1-.8-1.5-.9-3.2-.4-4.7.2-.5.4-.9.6-1.3l4.9,9.4c-.5,0-1-.1-1.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M579.9,1895.8c-.5,1.6-1.6,2.9-3.1,3.6-.2.1-.4.2-.7.3l-5.7-11c.2-.1.4-.3.6-.4.9-.5,1.9-.7,2.9-.7,2.3,0,4.5,1.2,5.6,3.4.8,1.5.9,3.2.4,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M582.7,1894.1c0-1.5-.3-2.9-1-4.3-.7-1.3-1.6-2.4-2.8-3.2l9-4.6,3.4-1.7,3.9,7.4-12.5,6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M597.7,1893.7l-5.7,2.9,1.3,2.5,5.7-2.9-1.3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M600.2,1898.5l-5.7,2.9,1.6,3,5.7-2.9-1.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M602.9,1903.7l-5.7,2.9,1.5,2.9,5.7-2.9-1.5-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M510.2,1898.7l-5.7,2.9,1.3,2.5,5.7-2.9-1.3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M512.7,1903.4l-5.7,2.9,1.6,3,5.7-2.9-1.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M514.1,1913.1h0s-2.9,1.5-2.9,1.5l-1.5-2.9,5.7-2.9,1.5,2.9-2.9,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M515.2,1928.8l-3.9-7.4,1-.5,3.8,7.3s0,0,0,0l-1,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M518.5,1927.1l-3.9-7.4,4.4-2.2,3.8,7.3s0,0,0,0l-4.4,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M531.9,1940.3l-5.7,2.9,1.5,2.9,5.7-2.9-1.5-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M529.2,1935l-5.7,2.9,1.6,3,5.7-2.9-1.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M526.7,1930.3l-5.7,2.9,1.3,2.5,5.7-2.9-1.3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M525.1,1923.6s0,0,0,0l-3.8-7.3,2.5-1.3c0,1.5.3,2.9,1,4.3.7,1.3,1.6,2.4,2.8,3.2l-2.5,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M538.6,1917c-.5,1.6-1.6,2.9-3.1,3.6-1.5.8-3.2.9-4.8.4-1.6-.5-2.9-1.6-3.7-3.1-.8-1.5-.9-3.2-.4-4.7.5-1.6,1.6-2.9,3.1-3.6,1.5-.8,3.2-.9,4.8-.4,1.6.5,2.9,1.6,3.7,3.1.8,1.5.9,3.2.4,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M541.7,1882.5l-5.7,2.9,1.3,2.5,5.7-2.9-1.3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M544.2,1887.2l-5.7,2.9,1.6,3,5.7-2.9-1.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M545.6,1896.9h0l-2.9,1.5-1.5-2.9,5.7-2.9,1.5,2.9-2.9,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M544.3,1913.9l-3.9-7.4,1.6-.8,3.8,7.2c0,0,0,.1.1.2l-1.6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M563.4,1924.1l-5.7,2.9,1.5,2.9,5.7-2.9-1.5-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M560.7,1918.8l-5.7,2.9,1.6,3,5.7-2.9-1.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M555.3,1915.6s0,0,0,0c0,0,0,0,0,0l2.8-1.4,1.3,2.5-5.7,2.9-1.3-2.5,2.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M558,1906.8l-9.9,5.1c0,0,0-.1,0-.2l-3.8-7.2,9.9-5.1,3.5.6,1.7,3.3-1.4,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M561.6,1901.9l-1.3-2.5,3.3-1.7,1.3,2.5-3.3,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M607.3,1906.6l-7.9-15.2c-.2-.3-.4-.5-.8-.6-.3-.1-.7,0-1,0l-2.9,1.5-.7-1.3,3.4-1.7c.3-.2.5-.4.6-.7s0-.7,0-1l-5-9.7c-.2-.3-.4-.5-.8-.6-.3-.1-.7,0-1,0l-3.4,1.7-.5-1,2.9-1.5c.3-.2.5-.4.6-.7s0-.7,0-1l-7.9-15.2c-.3-.6-1.1-.9-1.7-.5l-8,4.1c-.3.2-.5.4-.6.7-.1.3,0,.7,0,1l7.9,15.2c.2.4.7.7,1.1.7s.4,0,.6-.1l2.9-1.5.5,1-9.6,5s0,0,0,0c-2.1-.5-4.2-.2-6.1.7-.6.3-1.1.7-1.6,1.1,0,0,0,0,0,0-.2.1-.4.3-.5.5-1,1-1.8,2.2-2.2,3.6-.4,1.4-.5,2.8-.3,4.2-.3-.6-1.1-.8-1.7-.5l-5.2,2.7-4.1-.7c-.3,0-.6,0-.8.1l-5,2.6-.5-1,2.9-1.5c.3-.2.5-.4.6-.7.1-.3,0-.7,0-1l-7.9-15.2c-.3-.6-1.1-.9-1.7-.5l-8,4.1c-.3.2-.5.4-.6.7-.1.3,0,.7,0,1l7.9,15.2c.2.3.4.5.7.6.1,0,.3,0,.4,0,.2,0,.4,0,.6-.1l2.9-1.5.5,1-8,4.1c-.6.3-.9,1.1-.5,1.7l1.3,2.4c-1-1-2.2-1.7-3.6-2.2-2.2-.7-4.6-.5-6.7.6-1.8.9-3.3,2.5-4.1,4.3,0,0-.1,0-.2,0l-7.4,3.8-.4-.8,2.9-1.5c.6-.3.9-1.1.5-1.7l-7.9-15.2c-.2-.3-.4-.5-.7-.6-.3-.1-.7,0-1,0l-8,4.1c-.6.3-.9,1.1-.5,1.7l7.9,15.2c.2.3.4.5.7.6.1,0,.3,0,.4,0,.2,0,.4,0,.6-.1l2.9-1.5.4.8-5.6,2.9c-.6.3-.9,1.1-.5,1.7l5,9.7c.2.4.7.7,1.1.7s.4,0,.6-.1l5.6-2.9.7,1.4-2.9,1.5c-.3.2-.5.4-.6.7-.1.3,0,.7,0,1l7.9,15.2c.2.4.7.7,1.1.7s.4,0,.6-.1l8-4.1c.3-.2.5-.4.6-.7.1-.3,0-.7,0-1l-7.9-15.2c-.2-.3-.4-.5-.8-.6-.3-.1-.7,0-1,0l-2.9,1.5-.7-1.4,7.4-3.8s0,0,0,0c.7.2,1.4.2,2.1.2,1.4,0,2.8-.3,4.1-1,2.1-1.1,3.6-2.9,4.4-5.1.4-1.4.5-2.8.3-4.1l1.3,2.5c.2.3.4.5.7.6.1,0,.3,0,.4,0,.2,0,.4,0,.6-.1l8-4.1.7,1.3-2.9,1.5c-.6.3-.9,1.1-.5,1.7l7.9,15.2c.2.4.7.7,1.1.7s.4,0,.6-.1l8-4.1c.3-.2.5-.4.6-.7.1-.3,0-.7,0-1l-7.9-15.2c-.2-.3-.4-.5-.7-.6-.3-.1-.7,0-1,0l-2.9,1.5-.7-1.3,5-2.6c.3-.1.5-.4.6-.7l1.4-3.5,5.5-2.9c.3-.2.5-.4.6-.7s0-.7,0-1h0c1,.9,2.2,1.6,3.6,2.1.9.3,1.8.4,2.7.4,1.4,0,2.8-.3,4.1-1,1.8-.9,3.3-2.5,4.1-4.3,0,0,.1,0,.2,0l9.6-5,.7,1.3-2.9,1.5c-.6.3-.9,1.1-.5,1.7l7.9,15.2c.2.3.4.5.7.6.1,0,.3,0,.4,0,.2,0,.4,0,.6-.1l8-4.1c.6-.3.9-1.1.5-1.7h0ZM504.5,1901.7l5.7-2.9,1.3,2.5-5.7,2.9-1.3-2.5ZM508.5,1909.4l-1.6-3,5.7-2.9,1.6,3-5.7,2.9ZM514.1,1913.1l-2.9,1.5-1.5-2.9,5.7-2.9,1.5,2.9-2.9,1.5h0ZM515.2,1928.8l-3.9-7.4,1-.5,3.8,7.3s0,0,0,0l-1,.5h0ZM518.5,1927.1l-3.9-7.4,4.4-2.2,3.8,7.3s0,0,0,0l-4.4,2.3ZM533.5,1943.2l-5.7,2.9-1.5-2.9,5.7-2.9,1.5,2.9ZM529.2,1935l1.6,3-5.7,2.9-1.6-3,5.7-2.9ZM526.7,1930.3l1.3,2.5-5.7,2.9-1.3-2.5,5.7-2.9ZM525.1,1923.6s0,0,0,0l-3.8-7.3,2.5-1.3c0,1.5.3,2.9,1,4.3.7,1.3,1.6,2.4,2.8,3.2l-2.5,1.3h0ZM538.6,1917c-.5,1.6-1.6,2.9-3.1,3.6-1.5.8-3.2.9-4.8.4-1.6-.5-2.9-1.6-3.7-3.1-.8-1.5-.9-3.2-.4-4.7.5-1.6,1.6-2.9,3.1-3.6,1.5-.8,3.2-.9,4.8-.4,1.6.5,2.9,1.6,3.7,3.1.8,1.5.9,3.2.4,4.7ZM536,1885.4l5.7-2.9,1.3,2.5-5.7,2.9-1.3-2.5ZM540,1893.2l-1.6-3,5.7-2.9,1.6,3-5.7,2.9ZM545.6,1896.9l-2.9,1.5-1.5-2.9,5.7-2.9,1.5,2.9-2.9,1.5h0ZM544.3,1913.9l-3.9-7.4,1.6-.8,3.8,7.2c0,0,0,.1.1.2l-1.6.8h0ZM565,1927l-5.7,2.9-1.5-2.9,5.7-2.9,1.5,2.9ZM560.7,1918.8l1.6,3-5.7,2.9-1.6-3,5.7-2.9ZM555.3,1915.6s0,0,0,0c0,0,0,0,0,0l2.8-1.4,1.3,2.5-5.7,2.9-1.3-2.5,2.8-1.4ZM558,1906.8l-9.9,5.1c0,0,0-.1,0-.2l-3.8-7.2,9.9-5.1,3.5.6,1.7,3.3-1.4,3.5h0ZM561.6,1901.9l-1.3-2.5,3.3-1.7,1.3,2.5-3.3,1.7h0ZM575.5,1865.1l5.7-2.9,1.3,2.5-5.7,2.9-1.3-2.5ZM579.5,1872.8l-1.6-3,5.7-2.9,1.6,3-5.7,2.9ZM582.2,1878l-1.5-2.9,5.7-2.9,1.5,2.9-5.7,2.9ZM572,1899.8c-1.6-.5-2.9-1.6-3.7-3.1-.8-1.5-.9-3.2-.4-4.7.2-.5.4-.9.6-1.3l4.9,9.4c-.5,0-1-.1-1.4-.3ZM579.9,1895.8c-.5,1.6-1.6,2.9-3.1,3.6-.2.1-.4.2-.7.3l-5.7-11c.2-.1.4-.3.6-.4.9-.5,1.9-.7,2.9-.7,2.3,0,4.5,1.2,5.6,3.4.8,1.5.9,3.2.4,4.7ZM582.7,1894.1c0-1.5-.3-2.9-1-4.3-.7-1.3-1.6-2.4-2.8-3.2l9-4.6,3.4-1.7,3.9,7.4-12.5,6.4h0ZM592,1896.7l5.7-2.9,1.3,2.5-5.7,2.9-1.3-2.5ZM596,1904.4l-1.6-3,5.7-2.9,1.6,3-5.7,2.9ZM598.8,1909.6l-1.5-2.9,5.7-2.9,1.5,2.9-5.7,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M534.1,1910.6c-1.2-.4-2.6-.3-3.7.3-2.4,1.2-3.3,4.2-2.1,6.5.6,1.1,1.6,2,2.9,2.4.5.2,1,.2,1.5.2.8,0,1.5-.2,2.2-.5,1.2-.6,2-1.6,2.4-2.8.4-1.2.3-2.5-.3-3.7-.6-1.1-1.6-2-2.9-2.4h0ZM534.8,1915.9c-.2.6-.6,1.1-1.1,1.3-.5.3-1.2.3-1.8.2-.6-.2-1.1-.6-1.4-1.1-.6-1.1-.1-2.5,1-3.1.3-.2.7-.3,1.1-.3s.5,0,.7.1c.6.2,1.1.6,1.4,1.1.3.5.3,1.2.2,1.7h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendScrollingBg);
export default __webpack_public_path__ + "static/media/ascend-scrolling-bg.3b993f0ede4516d032f60c89942cde29.svg";
export { ForwardRef as ReactComponent };